const stoneDirectory = {
    
        "stone-amethyst": {
        name: "Amethyst",
        description: "is a stone of calm, believed to open the mind to new ideas and promote mental clarity. Throughout history, royal families have worn Amethyst to symbolize higher aspirations and spiritual insight.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/amethyst.png?v=1641665860",
        hex: "#9966cc",
        property1: "calm",
        property2: "protection",
        short_description: "Amethyst is a stone of calm, believed to open the mind to new ideas and promote mental clarity.",
        website_description: "Amethyst is a stone of calm, believed to open the mind to new ideas and promote mental clarity. Throughout history, royal families have worn Amethyst to symbolize higher aspirations and spiritual insight.",
        origin: "Brazil, Uruguay",
        zodiac: "Pisces, Aquarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/amethyst_stone.png?v=1736361243",
        chakra: "crown"
    },
    
        "stone-africanturquoise": {
        name: "African Turquoise",
        description: "is a transformative stone, believed to encourage growth and positive change in one's life. In various African cultures, it has been esteemed as a symbol of life and renewal.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/africanturq.png?v=1641674255",
        hex: "#2f9c95",
        property1: "transformation",
        property2: "uplifting",
        short_description: "African Turquoise is a transformative stone, believed to encourage growth and positive change in one's life.",
        website_description: "African Turquoise is a transformative stone, believed to encourage growth and positive change in one's life. In various African cultures, it has been esteemed as a symbol of life and renewal.",
        origin: "Africa",
        zodiac: "Sagittarius, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/africanturqoise.png?v=1736370680",
        chakra: "heart"
    },
    
        "stone-amazonite": {
        name: "Amazonite",
        description: "is a stone of harmony, believed to enhance communication and align energies for better understanding. In ancient Egypt, Amazonite was appreciated for its beauty and used in amulets and jewelry to symbolize courage and truth.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/amazonite.png?v=1641667918",
        hex: "#7fffd4",
        property1: "harmony",
        property2: "truth",
        short_description: "Amazonite is a stone of harmony, believed to enhance communication and align energies for better understanding.",
        website_description: "Amazonite is a stone of harmony, believed to enhance communication and align energies for better understanding. In ancient Egypt, Amazonite was appreciated for its beauty and used in amulets and jewelry to symbolize courage and truth.",
        origin: "Brazil, Madagascar",
        zodiac: "Virgo, Aquarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/amazonite_aa0260f2-78e7-4f34-9bd7-03b6746ad622.png?v=1736370679",
        chakra: "throat"
    },
    
        "stone-angelite": {
        name: "Angelite",
        description: "is a stone of serenity, believed to foster a sense of peace and connectedness. Angelite has been used in various spiritual practices to enhance inner knowing and angelic communication, since its discovery in Peru.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/tanzanite.png?v=1642402996",
        hex: "#cacfe2",
        property1: "serenity",
        property2: "awareness",
        short_description: "Angelite is a stone of serenity, believed to foster a sense of peace and connectedness.",
        website_description: "Angelite is a stone of serenity, believed to foster a sense of peace and connectedness. Angelite has been used in various spiritual practices to enhance inner knowing and angelic communication, since its discovery in Peru.",
        origin: "Peru",
        zodiac: "Aquarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/angelite.png?v=1736370680",
        chakra: "throat"
    },
    
        "stone-apatite": {
        name: "Apatite",
        description: "is a stone of inspiration, believed to enhance creativity and stimulate intellectual pursuits. Ancient civilizations valued Apatite for its ability to aid in achieving clarity and focused intention.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/apatite.png?v=1641667918",
        hex: "#4682b4",
        property1: "inspiration",
        property2: "manifestation",
        short_description: "Apatite is a stone of inspiration, believed to enhance creativity and stimulate intellectual pursuits.",
        website_description: "Apatite is a stone of inspiration, believed to enhance creativity and stimulate intellectual pursuits. Ancient civilizations valued Apatite for its ability to aid in achieving clarity and focused intention.",
        origin: "Brazil, Madagascar",
        zodiac: "Gemini, Aquarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/apatite_87d0303c-a25e-451d-85a1-e2123a2de977.png?v=1736370679",
        chakra: "third-eye"
    },
    
        "stone-aquamarine": {
        name: "Aquamarine",
        description: "is a stone of calm, believed to clear the mind and reduce stress. Sailors in ancient times carried Aquamarine to protect them from the dangers of the sea and ensure safe passage.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/aquamarine.png?v=1641667918",
        hex: "#d3eff8",
        property1: "calm",
        property2: "clarity",
        short_description: "Aquamarine is a stone of calm, believed to clear the mind and reduce stress.",
        website_description: "Aquamarine is a stone of calm, believed to clear the mind and reduce stress. Sailors in ancient times carried Aquamarine to protect them from the dangers of the sea and ensure safe passage.",
        origin: "Pakistan, Brazil",
        zodiac: "Pisces, Aquarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/aquamarine_c149c3a7-de8d-4eb4-bed9-1abc6e0169cb.png?v=1736370680",
        chakra: "throat"
    },
    
        "stone-azurite": {
        name: "Azurite",
        description: "is a stone of insight, believed to deepen intuitive abilities and understanding. Historically, Azurite has been revered by ancient cultures for its vivid blue hue and association with divine wisdom.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/azurite.png?v=1641674255",
        hex: "#4a8fcc",
        property1: "insight",
        property2: "wisdom",
        short_description: "Azurite is a stone of insight, believed to deepen intuitive abilities and understanding.",
        website_description: "Azurite is a stone of insight, believed to deepen intuitive abilities and understanding. Historically, Azurite has been revered by ancient cultures for its vivid blue hue and association with divine wisdom.",
        origin: "Morocco, Namibia",
        zodiac: "Sagittarius, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/azurite_stone.png?v=1736444897",
        chakra: "third-eye"
    },
    
        "stone-blacktourmaline": {
        name: "Black Tourmaline",
        description: "is a stone of grounding, believed to stabilize and anchor the wearer into Earth's energies. In ancient lore, Black Tourmaline has been used as a powerful talisman to ward off negative forces.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/obsidian.png?v=1641674254",
        hex: "#0a0a0a",
        property1: "grounding",
        property2: "protection",
        short_description: "Black Tourmaline is a stone of grounding, believed to stabilize and anchor the wearer into Earth's energies.",
        website_description: "Black Tourmaline is a stone of grounding, believed to stabilize and anchor the wearer into Earth's energies. In ancient lore, Black Tourmaline has been used as a powerful talisman to ward off negative forces.",
        origin: "Brazil, Sri Lanka",
        zodiac: "Capricorn, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/black_tourmaline_stone.png?v=1736445725",
        chakra: "root"
    },
    
        "stone-blueagate": {
        name: "Blue Agate",
        description: "is a stone of tranquility, believed to soothe emotions and promote a calm atmosphere. Ancient civilizations admired Blue Agate for its ability to bring emotional balance and clarity.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/blueagate.png?v=1641674254",
        hex: "#5dadec",
        property1: "tranquility",
        property2: "cleansing",
        short_description: "Blue Agate is a stone of tranquility, believed to soothe emotions and promote a calm atmosphere.",
        website_description: "Blue Agate is a stone of tranquility, believed to soothe emotions and promote a calm atmosphere. Ancient civilizations admired Blue Agate for its ability to bring emotional balance and clarity.",
        origin: "Brazil, India",
        zodiac: "Gemini, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/blue_agate_stone.png?v=1736446481",
        chakra: "throat"
    },
    
        "stone-bluelaceagate": {
        name: "Blue Lace Agate",
        description: "is a stone of serenity, believed to enhance clear communication and expression. Ancient societies prized Blue Lace Agate for its calming energy and its ability to aid in truthful speech.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/bluelaceagate.png?v=1641667918",
        hex: "#7eb6ff",
        property1: "serenity",
        property2: "communication",
        short_description: "Blue Lace Agate is a stone of serenity, believed to enhance clear communication and expression.",
        website_description: "Blue Lace Agate is a stone of serenity, believed to enhance clear communication and expression. Ancient societies prized Blue Lace Agate for its calming energy and its ability to aid in truthful speech.",
        origin: "Namibia, South Africa",
        zodiac: "Gemini, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/blue_lace_agate.png?v=1736447845",
        chakra: "throat"
    },
    
        "stone-bluetigerseye": {
        name: "Blue Tiger's Eye",
        description: "is a stone of focus, believed to enhance concentration and maintain inner equilibrium. In various cultures, Blue Tiger's Eye has been used as a talisman for mental clarity and protection during challenging times.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/bluetigerseye.png?v=1674687414",
        hex: "#436b95",
        property1: "focus",
        property2: "balance",
        short_description: "Blue Tiger's Eye is a stone of focus, believed to enhance concentration and maintain inner equilibrium.",
        website_description: "Blue Tiger's Eye is a stone of focus, believed to enhance concentration and maintain inner equilibrium. In various cultures, Blue Tiger's Eye has been used as a talisman for mental clarity and protection during challenging times.",
        origin: "South Africa, India",
        zodiac: "Sagittarius, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/blue_tigers_eye.png?v=1736448414",
        chakra: "throat"
    },
    
        "stone-bronzite": {
        name: "Bronzite",
        description: "is a stone of strength, believed to bolster resilience and fortify one's inner power. Bronzite has been utilized since ancient times as a protective amulet, especially revered for its supposed warrior energy.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/bronzite.png?v=1641674254",
        hex: "#cd7f32",
        property1: "strength",
        property2: "protection",
        short_description: "Bronzite is a stone of strength, believed to bolster resilience and fortify one's inner power.",
        website_description: "Bronzite is a stone of strength, believed to bolster resilience and fortify one's inner power. Bronzite has been utilized since ancient times as a protective amulet, especially revered for its supposed warrior energy.",
        origin: "Norway, Austria",
        zodiac: "Leo, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/bronzite_stone.png?v=1736447261",
        chakra: "root"
    },
    
        "stone-carnelian": {
        name: "Carnelian",
        description: "is a stone of vitality, believed to invigorate the spirit and bolster inner strength. In ancient Egypt, Carnelian was used in talismans and amulets for its supposed power to energize and bring courage.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/carnelian.png?v=1641665860",
        hex: "#e97451",
        property1: "vitality",
        property2: "courage",
        short_description: "Carnelian is a stone of vitality, believed to invigorate the spirit and bolster inner strength.",
        website_description: "Carnelian is a stone of vitality, believed to invigorate the spirit and bolster inner strength. In ancient Egypt, Carnelian was used in talismans and amulets for its supposed power to energize and bring courage.",
        origin: "India, Madagascar",
        zodiac: "Aries, Leo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Carnelian_stone.png?v=1736447474",
        chakra: "sacral"
    },
    
        "stone-citrine": {
        name: "Citrine",
        description: "is a stone of abundance, believed to attract prosperity and inspire a sense of joy. In ancient times, Citrine was treasured as a talisman for merchants, thought to bring fortune and success in business.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/citrine.png?v=1641667918",
        hex: "#e4d00a",
        property1: "abundance",
        property2: "joy",
        short_description: "Citrine is a stone of abundance, believed to attract prosperity and inspire a sense of joy.",
        website_description: "Citrine is a stone of abundance, believed to attract prosperity and inspire a sense of joy. In ancient times, Citrine was treasured as a talisman for merchants, thought to bring fortune and success in business.",
        origin: "Brazil, Madagascar",
        zodiac: "Leo, Sagittarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/citrine_c140b719-5307-4e72-898e-1d664e8b8696.png?v=1736448547",
        chakra: "solar-plexus"
    },
    
        "stone-clearquartz": {
        name: "Clear Quartz",
        description: "is a stone of clarity, believed to amplify thoughts and enhance energy flow. Clear Quartz has been used by various cultures for its believed ability to store and amplify both energy and spiritual intentions.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/clearquartz.png?v=1641674254",
        hex: "#f0f0f0",
        property1: "clarity",
        property2: "energy",
        short_description: "Clear Quartz is a stone of clarity, believed to amplify thoughts and enhance energy flow.",
        website_description: "Clear Quartz is a stone of clarity, believed to amplify thoughts and enhance energy flow. Clear Quartz has been used by various cultures for its believed ability to store and amplify both energy and spiritual intentions.",
        origin: "Brazil, Madagascar",
        zodiac: "Leo, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/clear_quartz.png?v=1736448708",
        chakra: "crown"
    },
    
        "stone-cloudyquartz": {
        name: "Cloudy Quartz",
        description: "is a stone of tranquility, believed to bring a sense of calm and mental clarity. Ancient cultures revered Cloudy Quartz for its cloudy appearance, believing it held the wisdom of the skies and heavens.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/moonstone.png?v=1641667918",
        hex: "#d9d9d9",
        property1: "tranquility",
        property2: "clarity",
        short_description: "Cloudy Quartz is a stone of tranquility, believed to bring a sense of calm and mental clarity.",
        website_description: "Cloudy Quartz is a stone of tranquility, believed to bring a sense of calm and mental clarity. Ancient cultures revered Cloudy Quartz for its cloudy appearance, believing it held the wisdom of the skies and heavens.",
        origin: "Brazil, Madagascar",
        zodiac: "Cancer, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/cloudy_quartz.png?v=1736450210",
        chakra: "crown"
    },
    
        "stone-druzyagate": {
        name: "Druzy Agate",
        description: "is a stone of sparkle, believed to amplify the inherent energy of other crystals. Druzy Agate has been admired throughout history for its sparkling surface and its connection to divine energies.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/druzy.png?v=1641674255",
        hex: "#b0a1ce",
        property1: "sparkle",
        property2: "energy",
        short_description: "Druzy Agate is a stone of sparkle, believed to amplify the inherent energy of other crystals.",
        website_description: "Druzy Agate is a stone of sparkle, believed to amplify the inherent energy of other crystals. Druzy Agate has been admired throughout history for its sparkling surface and its connection to divine energies.",
        origin: "Brazil, United States",
        zodiac: "Cancer, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/druzy_agate.png?v=1736450593",
        chakra: "crown"
    },
    
        "stone-fluorite": {
        name: "Fluorite",
        description: "is a stone of focus, believed to help sharpen mental clarity and improve concentration. In ancient Rome, Fluorite was highly valued for its multi-colored hues and was often carved into decorative items and vessels.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/fluorite.png?v=1641667918",
        hex: "#7cfc00",
        property1: "focus",
        property2: "clarity",
        short_description: "Fluorite is a stone of focus, believed to help sharpen mental clarity and improve concentration.",
        website_description: "Fluorite is a stone of focus, believed to help sharpen mental clarity and improve concentration. In ancient Rome, Fluorite was highly valued for its multi-colored hues and was often carved into decorative items and vessels.",
        origin: "China, Mexico",
        zodiac: "Pisces, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/fluorite_ec1a670b-2702-48ed-a44e-1ffa279b60a6.png?v=1736450812",
        chakra: "third-eye"
    },
    
        "stone-garnet": {
        name: "Garnet",
        description: "is a stone of vitality, believed to enhance one's energy and bring about a balanced state of being. In ancient history, Garnet was treasured as a symbol of passion and courage, often used in both jewelry and armor for its protective qualities.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/garnet.png?v=1641675420",
        hex: "#8b0000",
        property1: "vitality",
        property2: "balance",
        short_description: "Garnet is a stone of vitality, believed to enhance one's energy and bring about a balanced state of being.",
        website_description: "Garnet is a stone of vitality, believed to enhance one's energy and bring about a balanced state of being. In ancient history, Garnet was treasured as a symbol of passion and courage, often used in both jewelry and armor for its protective qualities.",
        origin: "India, Madagascar",
        zodiac: "Aries, Leo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/garnet_d89c1a78-9c51-409e-881d-fb4da1521e83.png?v=1736450978",
        chakra: "root"
    },
    
        "stone-grayagate": {
        name: "Gray Agate",
        description: "is a stone of stability, believed to fortify one's resolve and provide a grounding influence. Gray Agate has historically been used by various cultures as a protective stone to impart strength during times of stress.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/gray-agate.jpg?v=1665087538",
        hex: "#808080",
        property1: "stability",
        property2: "grounding",
        short_description: "Gray Agate is a stone of stability, believed to fortify one's resolve and provide a grounding influence.",
        website_description: "Gray Agate is a stone of stability, believed to fortify one's resolve and provide a grounding influence. Gray Agate has historically been used by various cultures as a protective stone to impart strength during times of stress.",
        origin: "India, Brazil",
        zodiac: "Virgo, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/gray_agate.png?v=1736451121",
        chakra: "root"
    },
    
        "stone-graylabradorite": {
        name: "Gray Labradorite",
        description: "is a stone of protection, believed to shield the aura and facilitate transformative insights. In Inuit legends, Gray Labradorite is said to be created from the frozen fire of the Aurora Borealis, symbolizing the bridge between two worlds.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/labradoritelight.png?v=1641674255",
        hex: "#a9a9a9",
        property1: "protection",
        property2: "transformation",
        short_description: "Gray Labradorite is a stone of protection, believed to shield the aura and facilitate transformative insights.",
        website_description: "Gray Labradorite is a stone of protection, believed to shield the aura and facilitate transformative insights. In Inuit legends, Gray Labradorite is said to be created from the frozen fire of the Aurora Borealis, symbolizing the bridge between two worlds.",
        origin: "Canada, Finland",
        zodiac: "Leo, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Gray_Labradorite.png?v=1736454649",
        chakra: "third-eye"
    },
    
        "stone-greenaventurine": {
        name: "Green Aventurine",
        description: "is a stone of luck, believed to attract opportunities and promote personal growth. Ancient cultures treasured Green Aventurine as a talisman for good fortune and prosperity in ventures.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/greenaventurine.png?v=1641667918",
        hex: "#00a36c",
        property1: "luck",
        property2: "growth",
        short_description: "Green Aventurine is a stone of luck, believed to attract opportunities and promote personal growth.",
        website_description: "Green Aventurine is a stone of luck, believed to attract opportunities and promote personal growth. Ancient cultures treasured Green Aventurine as a talisman for good fortune and prosperity in ventures.",
        origin: "India, China",
        zodiac: "Cancer, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/green_aventurine.png?v=1736451419",
        chakra: "heart"
    },
    
        "stone-greenchalcedony": {
        name: "Green Chalcedony",
        description: "is a stone of abundance, believed to foster prosperity and grounding energy. Ancient healers utilized Green Chalcedony to attract wealth and maintain steady energy levels during rituals.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/greenchalcedony.png?v=1641674255",
        hex: "#83c788",
        property1: "undefined",
        property2: "undefined",
        short_description: "Green Chalcedony is a stone of abundance, believed to foster prosperity and grounding energy.",
        website_description: "Green Chalcedony is a stone of abundance, believed to foster prosperity and grounding energy. Ancient healers utilized Green Chalcedony to attract wealth and maintain steady energy levels during rituals.",
        origin: "India, Brazil",
        zodiac: "Gemini, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/green_chalcedony.png?v=1736451666",
        chakra: "heart"
    },
    
        "stone-hematite": {
        name: "Hematite",
        description: "is a stone of grounding, believed to provide stability and reinforce personal strength. Used by ancient warriors, Hematite was often employed as a talisman for protection and courage in battle.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/hematite.png?v=1641667919",
        hex: "#3d3c3a",
        property1: "grounding",
        property2: "strength",
        short_description: "Hematite is a stone of grounding, believed to provide stability and reinforce personal strength.",
        website_description: "Hematite is a stone of grounding, believed to provide stability and reinforce personal strength. Used by ancient warriors, Hematite was often employed as a talisman for protection and courage in battle.",
        origin: "Brazil, Morocco",
        zodiac: "Aries, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/hematite_e0264f58-a032-467b-8452-dcbe9500c697.png?v=1736452010",
        chakra: "root"
    },
    
        "stone-hematoidquartz": {
        name: "Hematoid Quartz",
        description: "is a stone of balance, believed to harmonize energies and improve focus. In ancient times, Hematoid Quartz was used by healers and priests for its believed ability to stabilize the mind and spirit.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/hematoidquartz.jpg?v=1657214659",
        hex: "#d4a1bc",
        property1: "balance",
        property2: "focus",
        short_description: "Hematoid Quartz is a stone of balance, believed to harmonize energies and improve focus.",
        website_description: "Hematoid Quartz is a stone of balance, believed to harmonize energies and improve focus. In ancient times, Hematoid Quartz was used by healers and priests for its believed ability to stabilize the mind and spirit.",
        origin: "Brazil, United States",
        zodiac: "Leo, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Hematoid_Quartz.png?v=1736452455",
        chakra: "root"
    },
    
        "stone-honeytigerseye": {
        name: "Honey Tiger's Eye",
        description: "is a stone of vitality, believed to invigorate the spirit and bolster self-confidence. In various cultures, Honey Tiger's Eye has been used as a protective talisman to enhance courage and bring good fortune.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/honeytigerseye.png?v=1641674254",
        hex: "#d4a017",
        property1: "vitality",
        property2: "confidence",
        short_description: "Honey Tiger's Eye is a stone of vitality, believed to invigorate the spirit and bolster self-confidence.",
        website_description: "Honey Tiger's Eye is a stone of vitality, believed to invigorate the spirit and bolster self-confidence. In various cultures, Honey Tiger's Eye has been used as a protective talisman to enhance courage and bring good fortune.",
        origin: "South Africa, India",
        zodiac: "Leo, Sagittarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Honey_Tiger_s_Eye.png?v=1736452740",
        chakra: "solar-plexus"
    },
    
        "stone-howlite": {
        name: "Howlite",
        description: "is a stone of calm, believed to soothe the mind and enhance mental awareness. Since its discovery in the 19th century, Howlite has been cherished for its calming appearance and ability to quiet the mind.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/howlite.png?v=1641667919",
        hex: "#e5e4e2",
        property1: "calm",
        property2: "awareness",
        short_description: "Howlite is a stone of calm, believed to soothe the mind and enhance mental awareness.",
        website_description: "Howlite is a stone of calm, believed to soothe the mind and enhance mental awareness. Since its discovery in the 19th century, Howlite has been cherished for its calming appearance and ability to quiet the mind.",
        origin: "Canada, United States",
        zodiac: "Gemini, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Howlite_45f9b4f4-1d01-4eab-a0c8-74464853e11c.png?v=1736453087",
        chakra: "crown"
    },
    
        "stone-indianagate": {
        name: "Indian Agate",
        description: "is a stone of stability, believed to foster a sense of security and grounding. Indian Agate has been cherished in Indian culture for its use in jewelry and talismans to ward off negative energies.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/mossagate_3426cf8d-cb3b-41bb-8d70-db9a61bcaaf4.png?v=1641705066",
        hex: "#4d5645",
        property1: "stability",
        property2: "protection",
        short_description: "Indian Agate is a stone of stability, believed to foster a sense of security and grounding.",
        website_description: "Indian Agate is a stone of stability, believed to foster a sense of security and grounding. Indian Agate has been cherished in Indian culture for its use in jewelry and talismans to ward off negative energies.",
        origin: "India, Brazil",
        zodiac: "Virgo, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Indian_Agate.png?v=1736453677",
        chakra: "heart"
    },
    
        "stone-jade": {
        name: "Jade",
        description: "is a stone of harmony, believed to balance energies and attract prosperity into the user's life. Historically, Jade has been revered in various cultures as a symbol of purity and wisdom, often used in important rituals and artifacts.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/jade.png?v=1641674254",
        hex: "#779768",
        property1: "harmony",
        property2: "prosperity",
        short_description: "Jade is a stone of harmony, believed to balance energies and attract prosperity into the user's life.",
        website_description: "Jade is a stone of harmony, believed to balance energies and attract prosperity into the user's life. Historically, Jade has been revered in various cultures as a symbol of purity and wisdom, often used in important rituals and artifacts.",
        origin: "China, Myanmar",
        zodiac: "Aries, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Jade_d0c5017f-1669-41eb-8e31-f4e20489dd79.png?v=1736453782",
        chakra: "heart"
    },
    
        "stone-labradorite": {
        name: "Labradorite",
        description: "is a stone of transformation, believed to ease transitions and protect one’s aura. Inuit legends tell that Labradorite fell from the frozen fire of the Aurora Borealis, linking it to celestial energies.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/labrodorite.png?v=1641674255",
        hex: "#6d8099",
        property1: "transformation",
        property2: "protection",
        short_description: "Labradorite is a stone of transformation, believed to ease transitions and protect one’s aura.",
        website_description: "Labradorite is a stone of transformation, believed to ease transitions and protect one’s aura. Inuit legends tell that Labradorite fell from the frozen fire of the Aurora Borealis, linking it to celestial energies.",
        origin: "Canada, Madagascar",
        zodiac: "Sagittarius, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/labradorite.png?v=1736454146",
        chakra: "third-eye"
    },
    
        "stone-lapislazuli": {
        name: "Lapis Lazuli",
        description: "is a stone of awareness, believed to heighten self-knowledge and insight. In ancient Egypt, Lapis Lazuli was used by royalty and priests to invoke divine favor and protection.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/lapis.png?v=1650303627",
        hex: "#26619c",
        property1: "awareness",
        property2: "protection",
        short_description: "Lapis Lazuli is a stone of awareness, believed to heighten self-knowledge and insight.",
        website_description: "Lapis Lazuli is a stone of awareness, believed to heighten self-knowledge and insight. In ancient Egypt, Lapis Lazuli was used by royalty and priests to invoke divine favor and protection.",
        origin: "Afghanistan, Chile",
        zodiac: "Sagittarius, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Lapis_Lazuli.png?v=1736454995",
        chakra: "throat"
    },
    
        "stone-larimar": {
        name: "Larimar",
        description: "is a stone of serenity, believed to encourage relaxation and inner peace. Believed to be a gift from the sea, Larimar has been treasured in Caribbean cultures for its soothing blue color.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Larimar.png?v=1674686038",
        hex: "#68cde6",
        property1: "serenity",
        property2: "healing",
        short_description: "Larimar is a stone of serenity, believed to encourage relaxation and inner peace.",
        website_description: "Larimar is a stone of serenity, believed to encourage relaxation and inner peace. Believed to be a gift from the sea, Larimar has been treasured in Caribbean cultures for its soothing blue color.",
        origin: "Dominican Republic",
        zodiac: "Leo, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Larimar_c79c833d-162f-42cf-99a6-f5b213c6d8c8.png?v=1736455232",
        chakra: "throat"
    },
    
        "stone-lavastone": {
        name: "Lava Stone",
        description: "is a grounding stone, believed to provide stability and inner strength during times of change. Lava Stone has been used across various cultures as a talisman for protection and resilience against adversity.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/lavastone.png?v=1641665860",
        hex: "#302b27",
        property1: "grounding",
        property2: "strength",
        short_description: "Lava Stone is a grounding stone, believed to provide stability and inner strength during times of change.",
        website_description: "Lava Stone is a grounding stone, believed to provide stability and inner strength during times of change. Lava Stone has been used across various cultures as a talisman for protection and resilience against adversity.",
        origin: "Hawaii, Iceland",
        zodiac: "Capricorn, Aquarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Lava_Stone.png?v=1736455387",
        chakra: "root"
    },
    
        "stone-lavenderquartz": {
        name: "Lavender Quartz",
        description: "is a stone of serenity, believed to promote feelings of peace and unconditional love. Lavender Quartz has been cherished in folklore as a symbol of love and emotional healing, often used in romantic rituals.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Larimar_1.png?v=1674686182",
        hex: "#d7bde2",
        property1: "serenity",
        property2: "love",
        short_description: "Lavender Quartz is a stone of serenity, believed to promote feelings of peace and unconditional love.",
        website_description: "Lavender Quartz is a stone of serenity, believed to promote feelings of peace and unconditional love. Lavender Quartz has been cherished in folklore as a symbol of love and emotional healing, often used in romantic rituals.",
        origin: "Brazil, Madagascar",
        zodiac: "Libra, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Lavender_Quartz.png?v=1736455541",
        chakra: "heart"
    },
    
        "stone-lepidolite": {
        name: "Lepidolite",
        description: "is a stone of tranquility, believed to stabilize emotions and foster inner peace. Ancient healers valued Lepidolite for its calming energy and used it to promote emotional harmony.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/lepidolite.png?v=1641667919",
        hex: "#b39eb5",
        property1: "tranquility",
        property2: "balance",
        short_description: "Lepidolite is a stone of tranquility, believed to stabilize emotions and foster inner peace.",
        website_description: "Lepidolite is a stone of tranquility, believed to stabilize emotions and foster inner peace. Ancient healers valued Lepidolite for its calming energy and used it to promote emotional harmony.",
        origin: "Brazil, United States",
        zodiac: "Libra, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Lepidolite_79fe48e3-67a7-497a-858f-5b6a0602f2a1.png?v=1736455728",
        chakra: "heart"
    },
    
        "stone-malachite": {
        name: "Malachite",
        description: "is a stone of transformation, believed to inspire growth and provide robust protection against negative influences. Inhabitants of ancient Egypt used Malachite for its vibrant color and considered it a symbol of protective and transformative powers.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/malachite.png?v=1641667919",
        hex: "#0bda51",
        property1: "transformation",
        property2: "protection",
        short_description: "Malachite is a stone of transformation, believed to inspire growth and provide robust protection against negative influences.",
        website_description: "Malachite is a stone of transformation, believed to inspire growth and provide robust protection against negative influences. Inhabitants of ancient Egypt used Malachite for its vibrant color and considered it a symbol of protective and transformative powers.",
        origin: "Democratic Republic of Congo, Zambia",
        zodiac: "Scorpio, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Malachite_e914a861-0069-4079-ac6c-e78db073edc0.png?v=1736455908",
        chakra: "heart"
    },
    
        "stone-moonstone": {
        name: "Moonstone",
        description: "is a stone of intuition, believed to enhance psychic abilities and emotional balance. Moonstone has been revered in many ancient cultures as a sacred stone, associated with divine feminine energy and lunar deities.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/moonstone.png?v=1641667918",
        hex: "#fffdf7",
        property1: "intuition",
        property2: "balance",
        short_description: "Moonstone is a stone of intuition, believed to enhance psychic abilities and emotional balance.",
        website_description: "Moonstone is a stone of intuition, believed to enhance psychic abilities and emotional balance. Moonstone has been revered in many ancient cultures as a sacred stone, associated with divine feminine energy and lunar deities.",
        origin: "Sri Lanka, India",
        zodiac: "Cancer, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Moonstone_27ffa9c0-29a2-4047-afa2-fb2fa0a56ad8.png?v=1736456206",
        chakra: "crown"
    },
    
        "stone-mossagate": {
        name: "Moss Agate",
        description: "is a stone of stability, believed to foster personal growth and connect one to nature's rhythms. In ancient cultures, Moss Agate was prized for its lush, plant-like appearance and thought to bring a bountiful harvest.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/mossagate_3426cf8d-cb3b-41bb-8d70-db9a61bcaaf4.png?v=1641705066",
        hex: "#506d4f",
        property1: "stability",
        property2: "growth",
        short_description: "Moss Agate is a stone of stability, believed to foster personal growth and connect one to nature's rhythms.",
        website_description: "Moss Agate is a stone of stability, believed to foster personal growth and connect one to nature's rhythms. In ancient cultures, Moss Agate was prized for its lush, plant-like appearance and thought to bring a bountiful harvest.",
        origin: "United States, India",
        zodiac: "Virgo, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Moss_Agate.png?v=1736456560",
        chakra: "heart"
    },
    
        "stone-mysticquartz": {
        name: "Mystic Quartz",
        description: "is a stone of mysticism, believed to open gateways to higher realms of understanding. Mystic Quartz has been cherished by spiritual seekers for its dazzling hues and its association with mystical insights.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/mysticquartz.png?v=1641674254",
        hex: "#8e44ad",
        property1: "mysticism",
        property2: "insight",
        short_description: "Mystic Quartz is a stone of mysticism, believed to open gateways to higher realms of understanding.",
        website_description: "Mystic Quartz is a stone of mysticism, believed to open gateways to higher realms of understanding. Mystic Quartz has been cherished by spiritual seekers for its dazzling hues and its association with mystical insights.",
        origin: "Brazil, Madagascar",
        zodiac: "Scorpio, Aquarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Mystic_Quartz.png?v=1736456833",
        chakra: "third-eye"
    },
    
        "stone-obsidian": {
        name: "Obsidian",
        description: "is a stone of protection, believed to shield against negative energies and ground spiritual endeavors. In ancient times, Obsidian was used by various cultures for tool-making and ceremonial purposes due to its sharp edges and mystical properties.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/obsidian.png?v=1641674254",
        hex: "#100c08",
        property1: "protection",
        property2: "grounding",
        short_description: "Obsidian is a stone of protection, believed to shield against negative energies and ground spiritual endeavors.",
        website_description: "Obsidian is a stone of protection, believed to shield against negative energies and ground spiritual endeavors. In ancient times, Obsidian was used by various cultures for tool-making and ceremonial purposes due to its sharp edges and mystical properties.",
        origin: "Mexico, United States",
        zodiac: "Scorpio, Sagittarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Obsidian_4f5e8268-8ff7-4f47-879d-c4634ada6a5e.png?v=1736456971",
        chakra: "root"
    },
    
        "stone-opalite": {
        name: "Opalite",
        description: "is a stone of harmony, believed to enhance communication and facilitate clear expression of one's thoughts. Opalite, often used in modern metaphysical practices, has gained popularity for its serene glow and believed ability to connect with higher realms.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/opalite.png?v=1641705777",
        hex: "#a2c4c9",
        property1: "harmony",
        property2: "communication",
        short_description: "Opalite is a stone of harmony, believed to enhance communication and facilitate clear expression of one's thoughts.",
        website_description: "Opalite is a stone of harmony, believed to enhance communication and facilitate clear expression of one's thoughts. Opalite, often used in modern metaphysical practices, has gained popularity for its serene glow and believed ability to connect with higher realms.",
        origin: "China, India",
        zodiac: "Gemini, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Opalite_62855387-4784-4652-8db4-3af4e2e12126.png?v=1736457164",
        chakra: "throat"
    },
    
        "stone-peachmoonstone": {
        name: "Peach Moonstone",
        description: "is a stone of intuition, believed to enhance inner wisdom and provide soothing energies. Peach Moonstone has been cherished in various cultures for its gentle energy, often used in rituals to honor the moon and its cycles.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/peachmoonstone.png?v=1641674255",
        hex: "#ffcba4",
        property1: "intuition",
        property2: "soothing",
        short_description: "Peach Moonstone is a stone of intuition, believed to enhance inner wisdom and provide soothing energies.",
        website_description: "Peach Moonstone is a stone of intuition, believed to enhance inner wisdom and provide soothing energies. Peach Moonstone has been cherished in various cultures for its gentle energy, often used in rituals to honor the moon and its cycles.",
        origin: "India, Sri Lanka",
        zodiac: "Cancer, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Peach_Moonstone.png?v=1736457863",
        chakra: "sacral"
    },
    
        "stone-peridot": {
        name: "Peridot",
        description: "is a stone of healing, believed to restore emotional balance and encourage positive growth. Historically, Peridot has been cherished as a symbol of the sun and used by ancient cultures for its vibrant green hue to ward off evil spirits.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/peridot.png?v=1641705393",
        hex: "#b0e57c",
        property1: "healing",
        property2: "balance",
        short_description: "Peridot is a stone of healing, believed to restore emotional balance and encourage positive growth.",
        website_description: "Peridot is a stone of healing, believed to restore emotional balance and encourage positive growth. Historically, Peridot has been cherished as a symbol of the sun and used by ancient cultures for its vibrant green hue to ward off evil spirits.",
        origin: "Pakistan, United States",
        zodiac: "Leo, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Peridot_512e123b-bb8f-43e5-9a2f-2f1b2e9e9eb0.png?v=1736458102",
        chakra: "heart"
    },
    
        "stone-picturejasper": {
        name: "Picture Jasper",
        description: "is a stone of grounding, believed to bring about emotional balance and a deeper connection to the earth. Ancient civilizations valued Picture Jasper for its beautiful patterns and used it as a canvas for carvings and landscapes.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/picturejasper.png?v=1641705285",
        hex: "#d3b99c",
        property1: "grounding",
        property2: "balance",
        short_description: "Picture Jasper is a stone of grounding, believed to bring about emotional balance and a deeper connection to the earth.",
        website_description: "Picture Jasper is a stone of grounding, believed to bring about emotional balance and a deeper connection to the earth. Ancient civilizations valued Picture Jasper for its beautiful patterns and used it as a canvas for carvings and landscapes.",
        origin: "United States, Australia",
        zodiac: "Leo, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Picture_Jasper.png?v=1736458547",
        chakra: "root"
    },
    
        "stone-pinkaventurine": {
        name: "Pink Aventurine",
        description: "is a stone of balance, believed to harmonize emotional states and inspire compassion. Ancient cultures valued Pink Aventurine for its gentle pink hue, often associating it with love and heart-centered practices.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/pinkaventurine.png?v=1641674255",
        hex: "#f4c2c2",
        property1: "balance",
        property2: "compassion",
        short_description: "Pink Aventurine is a stone of balance, believed to harmonize emotional states and inspire compassion.",
        website_description: "Pink Aventurine is a stone of balance, believed to harmonize emotional states and inspire compassion. Ancient cultures valued Pink Aventurine for its gentle pink hue, often associating it with love and heart-centered practices.",
        origin: "India, Brazil",
        zodiac: "Libra, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Pink_Aventurine.png?v=1736458802",
        chakra: "heart"
    },
    
        "stone-pinktourmaline": {
        name: "Pink Tourmaline",
        description: "is a stone of love, believed to enhance emotional healing and compassion. Ancient healers valued Pink Tourmaline for its gentle energy, often using it in rituals to promote love and emotional balance.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/pink_tourmaline_stone.jpg?v=1646328644",
        hex: "#f48fb1",
        property1: "love",
        property2: "healing",
        short_description: "Pink Tourmaline is a stone of love, believed to enhance emotional healing and compassion.",
        website_description: "Pink Tourmaline is a stone of love, believed to enhance emotional healing and compassion. Ancient healers valued Pink Tourmaline for its gentle energy, often using it in rituals to promote love and emotional balance.",
        origin: "Afghanistan, Brazil",
        zodiac: "Libra, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/pink_tourmaline.png?v=1736531958",
        chakra: "heart"
    },
    
        "stone-purplejasper": {
        name: "Purple Jasper",
        description: "is a stone of resilience, believed to fortify one's spirit and provide protection against negative energies. Historically, Purple Jasper has been used by various cultures as a protective talisman to enhance inner strength and ward off harm.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Purple_Jasper.png?v=1674686311",
        hex: "#7d3c98",
        property1: "resilience",
        property2: "protection",
        short_description: "Purple Jasper is a stone of resilience, believed to fortify one's spirit and provide protection against negative energies.",
        website_description: "Purple Jasper is a stone of resilience, believed to fortify one's spirit and provide protection against negative energies. Historically, Purple Jasper has been used by various cultures as a protective talisman to enhance inner strength and ward off harm.",
        origin: "Brazil, South Africa",
        zodiac: "Aries, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/purple_jasper_05add6eb-56eb-4624-93d1-05ca50a2f0e9.png?v=1736532286",
        chakra: "root"
    },
    
        "stone-pyrite": {
        name: "Pyrite",
        description: "is a stone of prosperity, believed to attract wealth and abundance while shielding against negative influences. Throughout history, Pyrite was known as 'Fool’s Gold' and valued by ancient civilizations for its resemblance to gold and its perceived metaphysical properties.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/pyrite.png?v=1667339058",
        hex: "#b87333",
        property1: "prosperity",
        property2: "protection",
        short_description: "Pyrite is a stone of prosperity, believed to attract wealth and abundance while shielding against negative influences.",
        website_description: "Pyrite is a stone of prosperity, believed to attract wealth and abundance while shielding against negative influences. Throughout history, Pyrite was known as 'Fool’s Gold' and valued by ancient civilizations for its resemblance to gold and its perceived metaphysical properties.",
        origin: "Spain, Peru",
        zodiac: "Leo, Aries",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/pyrite_f4cab60c-d5da-40bd-9820-97f18e50e019.png?v=1736537220",
        chakra: "solar-plexus"
    },
    
        "stone-redjasper": {
        name: "Red Jasper",
        description: "is a stone of strength, believed to enhance endurance and foster a stable grounding energy. Throughout history, Red Jasper has been revered by various cultures for its protective qualities and used in talismans to ward off negative influences.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/redjasper.png?v=1641667918",
        hex: "#b22222",
        property1: "strength",
        property2: "stability",
        short_description: "Red Jasper is a stone of strength, believed to enhance endurance and foster a stable grounding energy.",
        website_description: "Red Jasper is a stone of strength, believed to enhance endurance and foster a stable grounding energy. Throughout history, Red Jasper has been revered by various cultures for its protective qualities and used in talismans to ward off negative influences.",
        origin: "India, Madagascar",
        zodiac: "Aries, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/red_jasper.png?v=1736537674",
        chakra: "root"
    },
    
        "stone-redmagnesite": {
        name: "Red Magnesite",
        description: "is a stone of serenity, believed to foster emotional healing and bring inner peace. Red Magnesite has been appreciated in various cultures for its calming properties and its ability to aid in meditation.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/redmagnesite.jpg?v=1657213745",
        hex: "#c24742",
        property1: "serenity",
        property2: "healing",
        short_description: "Red Magnesite is a stone of serenity, believed to foster emotional healing and bring inner peace.",
        website_description: "Red Magnesite is a stone of serenity, believed to foster emotional healing and bring inner peace. Red Magnesite has been appreciated in various cultures for its calming properties and its ability to aid in meditation.",
        origin: "Brazil, South Africa",
        zodiac: "Libra, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/red_magnesite.png?v=1736539449",
        chakra: "heart"
    },
    
        "stone-redtigerseye": {
        name: "Red Tiger's Eye",
        description: "is a stone of motivation, believed to invigorate one's drive and determination. In ancient cultures, Red Tiger's Eye was often carried as a talisman to protect against misfortune and inspire courage.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/redtigerseye.png?v=1641667919",
        hex: "#a52a2a",
        property1: "motivation",
        property2: "protection",
        short_description: "Red Tiger's Eye is a stone of motivation, believed to invigorate one's drive and determination.",
        website_description: "Red Tiger's Eye is a stone of motivation, believed to invigorate one's drive and determination. In ancient cultures, Red Tiger's Eye was often carried as a talisman to protect against misfortune and inspire courage.",
        origin: "South Africa, India",
        zodiac: "Aries, Sagittarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/red_tiger_s_eye.png?v=1736540068",
        chakra: "root"
    },
    
        "stone-rhodochrosite": {
        name: "Rhodochrosite",
        description: "is a stone of compassion, believed to open the heart and encourage deep emotional healing. Ancient civilizations valued Rhodochrosite for its vibrant pink color and used it in ceremonies to attract love and tenderness.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/rhodochrosite.png?v=1641667919",
        hex: "#ff6f61",
        property1: "compassion",
        property2: "healing",
        short_description: "Rhodochrosite is a stone of compassion, believed to open the heart and encourage deep emotional healing.",
        website_description: "Rhodochrosite is a stone of compassion, believed to open the heart and encourage deep emotional healing. Ancient civilizations valued Rhodochrosite for its vibrant pink color and used it in ceremonies to attract love and tenderness.",
        origin: "Argentina, South Africa",
        zodiac: "Leo, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/rhodochrosite_a260d237-92e7-4f3b-aeb9-a1277feda5e8.png?v=1736540842",
        chakra: "heart"
    },
    
        "stone-rhodonite": {
        name: "Rhodonite",
        description: "is a stone of compassion, believed to balance emotions and promote unconditional love. Ancient healers used Rhodonite in their rituals, valuing its ability to heal emotional wounds and foster peace.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/rhodonite.png?v=1641667919",
        hex: "#e82c4f",
        property1: "compassion",
        property2: "balance",
        short_description: "Rhodonite is a stone of compassion, believed to balance emotions and promote unconditional love.",
        website_description: "Rhodonite is a stone of compassion, believed to balance emotions and promote unconditional love. Ancient healers used Rhodonite in their rituals, valuing its ability to heal emotional wounds and foster peace.",
        origin: "Russia, Brazil",
        zodiac: "Taurus, Aries",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/rhodonite_06ba88ea-0361-4426-abfb-3ec927ce6f2f.png?v=1736541096",
        chakra: "heart"
    },
    
        "stone-rosequartz": {
        name: "Rose Quartz",
        description: "is a stone of love, believed to foster deep emotional connections and harmonize relationships. Throughout history, Rose Quartz has been prized by many cultures for its gentle pink hue and its association with love and compassion.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/rosequartz.png?v=1641667918",
        hex: "#ffc0cb",
        property1: "love",
        property2: "harmony",
        short_description: "Rose Quartz is a stone of love, believed to foster deep emotional connections and harmonize relationships.",
        website_description: "Rose Quartz is a stone of love, believed to foster deep emotional connections and harmonize relationships. Throughout history, Rose Quartz has been prized by many cultures for its gentle pink hue and its association with love and compassion.",
        origin: "Brazil, Madagascar",
        zodiac: "Taurus, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/rose_quartz.png?v=1736541456",
        chakra: "heart"
    },
    
        "stone-sandalwood": {
        name: "Sandalwood",
        description: "is a stone of calm, believed to soothe the mind and body, fostering tranquility. Historically, Sandalwood has been used in numerous religious and spiritual practices for its grounding and purifying properties.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/sandalwood.png?v=1641674254",
        hex: "#c8ad7f",
        property1: "calm",
        property2: "grounding",
        short_description: "Sandalwood is a stone of calm, believed to soothe the mind and body, fostering tranquility.",
        website_description: "Sandalwood is a stone of calm, believed to soothe the mind and body, fostering tranquility. Historically, Sandalwood has been used in numerous religious and spiritual practices for its grounding and purifying properties.",
        origin: "India, Indonesia",
        zodiac: "Taurus, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/sandalwood_594273da-7ddc-407c-b28d-887f58615afb.png?v=1736541677",
        chakra: "root"
    },
    
        "stone-selenite": {
        name: "Selenite",
        description: "is a stone of clarity, believed to clear the mind and spiritual pathways. Ancient civilizations revered Selenite for its translucent beauty and its believed ability to purify spaces and objects.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/9814923849.png?v=1641674370",
        hex: "#e1e3e1",
        property1: "clarity",
        property2: "purification",
        short_description: "Selenite is a stone of clarity, believed to clear the mind and spiritual pathways.",
        website_description: "Selenite is a stone of clarity, believed to clear the mind and spiritual pathways. Ancient civilizations revered Selenite for its translucent beauty and its believed ability to purify spaces and objects.",
        origin: "Morocco, Mexico",
        zodiac: "Cancer, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Selenite.png?v=1736460201",
        chakra: "crown"
    },
    
        "stone-silverleafjasper": {
        name: "Silver Leaf Jasper",
        description: "is a stone of stability, believed to enhance one's inner strength and shield against negative influences. Silver Leaf Jasper has been prized in various cultures for its intricate patterns, often resembling delicate leaves, symbolizing growth and protection.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/silverleafjasper_1.jpg?v=1657213995",
        hex: "#b0c4de",
        property1: "stability",
        property2: "protection",
        short_description: "Silver Leaf Jasper is a stone of stability, believed to enhance one's inner strength and shield against negative influences.",
        website_description: "Silver Leaf Jasper is a stone of stability, believed to enhance one's inner strength and shield against negative influences. Silver Leaf Jasper has been prized in various cultures for its intricate patterns, often resembling delicate leaves, symbolizing growth and protection.",
        origin: "Brazil, South Africa",
        zodiac: "Gemini, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Silver_Leaf_Jasper.png?v=1736459938",
        chakra: "root"
    },
    
        "stone-smokyquartz": {
        name: "Smoky Quartz",
        description: "is a stone of clarity, believed to dispel confusion and enhance grounded thinking. Ancient cultures regarded Smoky Quartz as a protective stone, using it to ward off negative energies and environmental stress.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/smokyquartz_60bdefc3-0552-4cb7-9d49-48ac14f072bf.png?v=1641667919",
        hex: "#73503b",
        property1: "clarity",
        property2: "grounding",
        short_description: "Smoky Quartz is a stone of clarity, believed to dispel confusion and enhance grounded thinking.",
        website_description: "Smoky Quartz is a stone of clarity, believed to dispel confusion and enhance grounded thinking. Ancient cultures regarded Smoky Quartz as a protective stone, using it to ward off negative energies and environmental stress.",
        origin: "Brazil, Madagascar",
        zodiac: "Capricorn, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Smoky_Quartz.png?v=1736459680",
        chakra: "root"
    },
    
        "stone-snowquartz": {
        name: "Snow Quartz",
        description: "is a stone of purity, believed to cleanse the mind and enhance clarity of thought. Snow Quartz has been treasured in various cultures for its pristine appearance, symbolizing innocence and new beginnings.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/moonstone.png?v=1641667918",
        hex: "#ffffff",
        property1: "undefined",
        property2: "undefined",
        short_description: "Snow Quartz is a stone of purity, believed to cleanse the mind and enhance clarity of thought.",
        website_description: "Snow Quartz is a stone of purity, believed to cleanse the mind and enhance clarity of thought. Snow Quartz has been treasured in various cultures for its pristine appearance, symbolizing innocence and new beginnings.",
        origin: "Brazil, United States",
        zodiac: "Capricorn, Aquarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Snow_Quartz.png?v=1736459492",
        chakra: "crown"
    },
    
        "stone-sodalite": {
        name: "Sodalite",
        description: "is a stone of insight, believed to enhance intuition and deepen understanding. Ancient civilizations valued Sodalite for its deep blue color and its reputed power to connect the physical and spiritual realms.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/sodalite.png?v=1641667919",
        hex: "#1e3d59",
        property1: "insight",
        property2: "intuition",
        short_description: "Sodalite is a stone of insight, believed to enhance intuition and deepen understanding.",
        website_description: "Sodalite is a stone of insight, believed to enhance intuition and deepen understanding. Ancient civilizations valued Sodalite for its deep blue color and its reputed power to connect the physical and spiritual realms.",
        origin: "Canada, Brazil",
        zodiac: "Sagittarius, Leo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Sodalite_1e754a23-dd24-49cc-b5e9-b38fd95dfe89.png?v=1736459334",
        chakra: "third-eye"
    },
    
        "stone-strawberryquartz": {
        name: "Strawberry Quartz",
        description: "is a stone of love, believed to infuse the aura with joy and positive energy. Ancient healers cherished Strawberry Quartz for its vibrant appearance and believed it to be a powerful symbol of emotional renewal.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/strawberryquartz_83a1d236-d0f0-4e09-9aa0-f80f9c66d30b.png?v=1641667919",
        hex: "#e7768b",
        property1: "love",
        property2: "joy",
        short_description: "Strawberry Quartz is a stone of love, believed to infuse the aura with joy and positive energy.",
        website_description: "Strawberry Quartz is a stone of love, believed to infuse the aura with joy and positive energy. Ancient healers cherished Strawberry Quartz for its vibrant appearance and believed it to be a powerful symbol of emotional renewal.",
        origin: "Brazil, Madagascar",
        zodiac: "Libra, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Strawberry_Quartz.png?v=1736459212",
        chakra: "heart"
    },
    
        "stone-sunstone": {
        name: "Sunstone",
        description: "is a stone of vitality, believed to invigorate the spirit and inspire a joyful outlook. Throughout history, Sunstone has been revered for its vibrant shimmer, often associated with the energy of the sun and used to uplift spirits.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/sunstone.png?v=1641705912",
        hex: "#ffa200",
        property1: "vitality",
        property2: "positivity",
        short_description: "Sunstone is a stone of vitality, believed to invigorate the spirit and inspire a joyful outlook.",
        website_description: "Sunstone is a stone of vitality, believed to invigorate the spirit and inspire a joyful outlook. Throughout history, Sunstone has been revered for its vibrant shimmer, often associated with the energy of the sun and used to uplift spirits.",
        origin: "India, Norway",
        zodiac: "Leo, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Sunstone_5e675176-93a5-4472-9a51-d22aeaf58177.png?v=1736458975",
        chakra: "sacral"
    },
    
        "stone-tigerseye": {
        name: "Tiger's Eye",
        description: "is a stone of courage, believed to bolster confidence and provide grounding energy. In ancient times, Tiger's Eye was favored as a protective talisman to ward off curses and ill wishes.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/tigerseye.png?v=1641665860",
        hex: "#e08d3c",
        property1: "courage",
        property2: "protection",
        short_description: "Tiger's Eye is a stone of courage, believed to bolster confidence and provide grounding energy.",
        website_description: "Tiger's Eye is a stone of courage, believed to bolster confidence and provide grounding energy. In ancient times, Tiger's Eye was favored as a protective talisman to ward off curses and ill wishes.",
        origin: "South Africa, Western Australia",
        zodiac: "Leo, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/tigerseye_d9c7e2b2-dcaa-447d-8667-5d22598982c9.png?v=1736370679",
        chakra: "solar-plexus"
    },
    
        "stone-tourmalinatedquartz": {
        name: "Tourmalinated Quartz",
        description: "is a stone of clarity, believed to harmonize and shield the spirit while enhancing clear thought. Renowned for its unique appearance, Tourmalinated Quartz has been considered a powerful tool for balancing opposing energies and has been utilized in spiritual practices to protect the mind.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/tourmalinatedquartz.png?v=1641674255",
        hex: "#cfcfcf",
        property1: "clarity",
        property2: "protection",
        short_description: "Tourmalinated Quartz is a stone of clarity, believed to harmonize and shield the spirit while enhancing clear thought.",
        website_description: "Tourmalinated Quartz is a stone of clarity, believed to harmonize and shield the spirit while enhancing clear thought. Renowned for its unique appearance, Tourmalinated Quartz has been considered a powerful tool for balancing opposing energies and has been utilized in spiritual practices to protect the mind.",
        origin: "Brazil, India",
        zodiac: "Aquarius, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Tourmalinated_Quartz.png?v=1736784626",
        chakra: "crown"
    },
    
        "stone-turquoise": {
        name: "Turquoise",
        description: "is a stone of healing, believed to support overall wellbeing and safeguard against negative influences. Ancient civilizations, especially Native American tribes, revered Turquoise as a sacred stone of protection and used it in ceremonial artifacts.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/turqoise_1.jpg?v=1657214225",
        hex: "#40e0d0",
        property1: "healing",
        property2: "protection",
        short_description: "Turquoise is a stone of healing, believed to support overall wellbeing and safeguard against negative influences.",
        website_description: "Turquoise is a stone of healing, believed to support overall wellbeing and safeguard against negative influences. Ancient civilizations, especially Native American tribes, revered Turquoise as a sacred stone of protection and used it in ceremonial artifacts.",
        origin: "Iran, United States",
        zodiac: "Sagittarius, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Turquoise.png?v=1736784905",
        chakra: "throat"
    },
    
        "stone-unakite": {
        name: "Unakite",
        description: "is a stone of balance, believed to harmonize emotions and promote holistic healing. Unakite has been revered in various cultures as a symbol of emotional resilience and physical vitality.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/unakite.png?v=1641667919",
        hex: "#d33f49",
        property1: "balance",
        property2: "healing",
        short_description: "Unakite is a stone of balance, believed to harmonize emotions and promote holistic healing.",
        website_description: "Unakite is a stone of balance, believed to harmonize emotions and promote holistic healing. Unakite has been revered in various cultures as a symbol of emotional resilience and physical vitality.",
        origin: "North Carolina, South Africa",
        zodiac: "Scorpio, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/unakite_0d8e70f6-ff7b-477c-8177-86932aa26558.png?v=1736785748",
        chakra: "heart"
    },
    
        "stone-whitejade": {
        name: "White Jade",
        description: "is a stone of serenity, believed to promote peacefulness and clear mental focus. Traditionally, White Jade has been esteemed in Chinese culture for its ability to foster purity and wisdom.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/moonstone.png?v=1641667918",
        hex: "#e8e8e8",
        property1: "serenity",
        property2: "clarity",
        short_description: "White Jade is a stone of serenity, believed to promote peacefulness and clear mental focus.",
        website_description: "White Jade is a stone of serenity, believed to promote peacefulness and clear mental focus. Traditionally, White Jade has been esteemed in Chinese culture for its ability to foster purity and wisdom.",
        origin: "China, Burma",
        zodiac: "Cancer, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/white_jade.png?v=1737050605",
        chakra: "crown"
    },
    
        "stone-yellowagate": {
        name: "Yellow Agate",
        description: "is a stone of focus, believed to sharpen concentration and bolster courage during challenging times. Yellow Agate has been valued in many cultures for its energizing hue and used in ancient talismans to enhance focus and bravery.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/yellowcalcite.png?v=1641667919",
        hex: "#ffd700",
        property1: "focus",
        property2: "courage",
        short_description: "Yellow Agate is a stone of focus, believed to sharpen concentration and bolster courage during challenging times.",
        website_description: "Yellow Agate is a stone of focus, believed to sharpen concentration and bolster courage during challenging times. Yellow Agate has been valued in many cultures for its energizing hue and used in ancient talismans to enhance focus and bravery.",
        origin: "India, Brazil",
        zodiac: "Leo, Sagittarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/yellow_agate.png?v=1737051337",
        chakra: "solar-plexus"
    },
    
        "stone-yellowcalcite": {
        name: "Yellow Calcite",
        description: "is a stone of clarity, believed to illuminate one's path with bright, positive energy. In ancient times, Yellow Calcite was revered for its vibrant color and was often used in rituals to invoke sunlight and warmth.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/yellowcalcite.png?v=1641667919",
        hex: "#ffd700",
        property1: "clarity",
        property2: "positivity",
        short_description: "Yellow Calcite is a stone of clarity, believed to illuminate one's path with bright, positive energy.",
        website_description: "Yellow Calcite is a stone of clarity, believed to illuminate one's path with bright, positive energy. In ancient times, Yellow Calcite was revered for its vibrant color and was often used in rituals to invoke sunlight and warmth.",
        origin: "Brazil, Mexico",
        zodiac: "Leo, Sagittarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/yellow_calcite.png?v=1737127344",
        chakra: "solar-plexus"
    },
    
        "stone-tanzanite": {
        name: "Tanzanite",
        description: "is a stone of enlightenment, believed to awaken a higher state of consciousness and spiritual awareness. Tanzanite was discovered in Tanzania and is known for its deep blue to violet hues, often linked to metaphysical transformations.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/tanzanite.png?v=1642402996",
        hex: "#7c64b8",
        property1: "enlightenment",
        property2: "transformation",
        short_description: "Tanzanite is a stone of enlightenment, believed to awaken a higher state of consciousness and spiritual awareness.",
        website_description: "Tanzanite is a stone of enlightenment, believed to awaken a higher state of consciousness and spiritual awareness. Tanzanite was discovered in Tanzania and is known for its deep blue to violet hues, often linked to metaphysical transformations.",
        origin: "Tanzania",
        zodiac: "Sagittarius, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Tanzanite_09dfaee7-6de0-4d08-bd73-433725b45dc9.png?v=1737127959",
        chakra: "third-eye"
    },
    
        "stone-motherofpearl": {
        name: "Mother Of Pearl",
        description: "is a stone of nurturing, believed to support emotional well-being and maternal energies. Ancient cultures have used Mother Of Pearl in jewelry and adornments to symbolize purity and protection.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/motherofpearl.png?v=1654120875",
        hex: "#fff5ee",
        property1: "nurturing",
        property2: "protection",
        short_description: "Mother Of Pearl is a stone of nurturing, believed to support emotional well-being and maternal energies.",
        website_description: "Mother Of Pearl is a stone of nurturing, believed to support emotional well-being and maternal energies. Ancient cultures have used Mother Of Pearl in jewelry and adornments to symbolize purity and protection.",
        origin: "Oceans, Seas",
        zodiac: "Cancer, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Mother_of_Pearl.png?v=1737128110",
        chakra: "solar-plexus"
    },
    
        "stone-redgoldstone": {
        name: "Red Goldstone",
        description: "is a stone of ambition, believed to inspire drive and motivate one toward achieving goals. In ancient times, Red Goldstone was known as the 'stone of ambition' and used by alchemists to bring success and encouragement.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/red_goldstone.jpg?v=1654120955",
        hex: "#c04c36",
        property1: "ambition",
        property2: "motivation",
        short_description: "Red Goldstone is a stone of ambition, believed to inspire drive and motivate one toward achieving goals.",
        website_description: "Red Goldstone is a stone of ambition, believed to inspire drive and motivate one toward achieving goals. In ancient times, Red Goldstone was known as the 'stone of ambition' and used by alchemists to bring success and encouragement.",
        origin: "Italy, China",
        zodiac: "Leo, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Red_Goldstone.png?v=1737128468",
        chakra: "sacral"
    },
    
        "stone-pinkagate": {
        name: "Pink Agate",
        description: "is a stone of compassion, believed to open the heart and foster protective energy. Historically, Pink Agate has been cherished for its delicate pink hues and used in protective amulets to ward off negative forces.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/pink_agate.png?v=1654121444",
        hex: "#ffb6c1",
        property1: "compassion",
        property2: "protection",
        short_description: "Pink Agate is a stone of compassion, believed to open the heart and foster protective energy.",
        website_description: "Pink Agate is a stone of compassion, believed to open the heart and foster protective energy. Historically, Pink Agate has been cherished for its delicate pink hues and used in protective amulets to ward off negative forces.",
        origin: "Brazil, Madagascar",
        zodiac: "Libra, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Pink_Agate_66494c89-c9d6-4e26-8a51-42fdca26df55.png?v=1737128713",
        chakra: "heart"
    },
    
        "stone-greenagate": {
        name: "Green Agate",
        description: "is a stone of balance, believed to harmonize energies and support personal growth. In ancient cultures, Green Agate was often used in amulets for its believed ability to attract prosperity and nurture the spirit.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/greenagate.png?v=1654121315",
        hex: "#208320",
        property1: "balance",
        property2: "growth",
        short_description: "Green Agate is a stone of balance, believed to harmonize energies and support personal growth.",
        website_description: "Green Agate is a stone of balance, believed to harmonize energies and support personal growth. In ancient cultures, Green Agate was often used in amulets for its believed ability to attract prosperity and nurture the spirit.",
        origin: "India, United States",
        zodiac: "Taurus, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Green_Agate.png?v=1737128937",
        chakra: "heart"
    },
    
        "stone-redcreekjasper": {
        name: "Red Creek Jasper",
        description: "is a stone of resilience, believed to foster inner strength and grounding energy. Red Creek Jasper has been treasured for its vibrant hues and unique patterns, often used in indigenous rituals to symbolize endurance.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/redcreekjasper.jpg?v=1657214394",
        hex: "#bf4f51",
        property1: "resilience",
        property2: "grounding",
        short_description: "Red Creek Jasper is a stone of resilience, believed to foster inner strength and grounding energy.",
        website_description: "Red Creek Jasper is a stone of resilience, believed to foster inner strength and grounding energy. Red Creek Jasper has been treasured for its vibrant hues and unique patterns, often used in indigenous rituals to symbolize endurance.",
        origin: "China, United States",
        zodiac: "Aries, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Red_Creek_Jasper.png?v=1737129156",
        chakra: "root"
    },
    
        "stone-blueaventurine": {
        name: "Blue Aventurine",
        description: "is a stone of courage, believed to boost confidence and support emotional healing. This stone has been used in several cultures as a talisman for protection and serenity, often found in amulets and decorative arts.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Untitled_design_35_a072fd45-432a-4470-8c87-d7411f426f38.png?v=1674685927",
        hex: "#5f9ea0",
        property1: "courage",
        property2: "healing",
        short_description: "Blue Aventurine is a stone of courage, believed to boost confidence and support emotional healing.",
        website_description: "Blue Aventurine is a stone of courage, believed to boost confidence and support emotional healing. This stone has been used in several cultures as a talisman for protection and serenity, often found in amulets and decorative arts.",
        origin: "Brazil, South Africa",
        zodiac: "Gemini, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Blue_Aventurine.png?v=1737386846",
        chakra: "throat"
    },
    
        "stone-redagate": {
        name: "Red Agate",
        description: "is a stone of resilience, believed to bolster strength and provide grounding support during challenging times. Throughout history, Red Agate has been valued by ancient civilizations for its deep red hues and its reputed ability to fortify the spirit.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Untitled_design_26.png?v=1664999515",
        hex: "#aa0000",
        property1: "resilience",
        property2: "strength",
        short_description: "Red Agate is a stone of resilience, believed to bolster strength and provide grounding support during challenging times.",
        website_description: "Red Agate is a stone of resilience, believed to bolster strength and provide grounding support during challenging times. Throughout history, Red Agate has been valued by ancient civilizations for its deep red hues and its reputed ability to fortify the spirit.",
        origin: "Brazil, India",
        zodiac: "Aries, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Red_Agate.png?v=1738163560",
        chakra: "root"
    },
    
        "stone-wengewood": {
        name: "Wenge Wood",
        description: "is a stone of grounding, believed to fortify one's resolve and provide strong grounding energies. Valued by various cultures, Wenge Wood has been used for its durability and deep, rich color in fine woodworking and spiritual practices.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/wengewood-icon.png?v=1660764635",
        hex: "#4B3621",
        property1: "grounding",
        property2: "strength",
        short_description: "Wenge Wood is a stone of grounding, believed to fortify one's resolve and provide strong grounding energies.",
        website_description: "Wenge Wood is a stone of grounding, believed to fortify one's resolve and provide strong grounding energies. Valued by various cultures, Wenge Wood has been used for its durability and deep, rich color in fine woodworking and spiritual practices.",
        origin: "",
        zodiac: "",
        tumbled: "",
        chakra: "root"
    },
    
        "stone-dalmatianjasper": {
        name: "Dalmatian Jasper",
        description: "is a stone of playfulness, believed to elevate the spirit and foster a joyful outlook. Dalmatian Jasper, often characterized by its distinctive spots, has been cherished for its unique appearance symbolizing spontaneity and fun.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/dalmation_jasper_64_x_64_px.png?v=1672953547",
        hex: "#a39170",
        property1: "playfulness",
        property2: "grounding",
        short_description: "Dalmatian Jasper is a stone of playfulness, believed to elevate the spirit and foster a joyful outlook.",
        website_description: "Dalmatian Jasper is a stone of playfulness, believed to elevate the spirit and foster a joyful outlook. Dalmatian Jasper, often characterized by its distinctive spots, has been cherished for its unique appearance symbolizing spontaneity and fun.",
        origin: "Mexico, South Africa",
        zodiac: "Gemini, Sagittarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Dalmatian_Jasper.png?v=1738163969",
        chakra: "root"
    },
    
        "stone-opal": {
        name: "Opal",
        description: "is a stone of creativity, believed to inspire artistic expression and enhance imagination. In ancient times, Opal was revered for its rainbow-like play of colors and considered a symbol of hope and purity.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/opal.png?v=1680021280",
        hex: "#ffb7c5",
        property1: "creativity",
        property2: "protection",
        short_description: "Opal is a stone of creativity, believed to inspire artistic expression and enhance imagination.",
        website_description: "Opal is a stone of creativity, believed to inspire artistic expression and enhance imagination. In ancient times, Opal was revered for its rainbow-like play of colors and considered a symbol of hope and purity.",
        origin: "Australia, Ethiopia",
        zodiac: "Cancer, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Opal_54b429ea-eeb8-4d20-bb57-7333de1dc618.png?v=1738164241",
        chakra: "crown"
    },
    
        "stone-pearl": {
        name: "Pearl",
        description: "is a stone of purity, believed to symbolize wisdom and enhance one's inner clarity. In ancient cultures, Pearls were prized as gifts from the sea gods and often worn by nobility to signify wealth and wisdom.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/pearl_icon_06c1af21-179c-466a-97b6-a8aee3b14d56.png?v=1680020939",
        hex: "#f7e7ce",
        property1: "purity",
        property2: "wisdom",
        short_description: "Pearl is a stone of purity, believed to symbolize wisdom and enhance one's inner clarity.",
        website_description: "Pearl is a stone of purity, believed to symbolize wisdom and enhance one's inner clarity. In ancient cultures, Pearls were prized as gifts from the sea gods and often worn by nobility to signify wealth and wisdom.",
        origin: "Oceans, Seas",
        zodiac: "Cancer, Gemini",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Pearl.png?v=1738164364",
        chakra: "crown"
    },
    
        "stone-purpleagate": {
        name: "Purple Agate",
        description: "is a stone of transformation, believed to foster deep changes and offer protective energies. Throughout history, Purple Agate has been revered for its ability to transform negative thoughts and was used in amulets for protection and spiritual clarity.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/purple_agate_64x64_5b319e65-b7d9-4743-8209-d05bd5db4371.png?v=1681140304",
        hex: "#6a0dad",
        property1: "transformation",
        property2: "protection",
        short_description: "Purple Agate is a stone of transformation, believed to foster deep changes and offer protective energies.",
        website_description: "Purple Agate is a stone of transformation, believed to foster deep changes and offer protective energies. Throughout history, Purple Agate has been revered for its ability to transform negative thoughts and was used in amulets for protection and spiritual clarity.",
        origin: "Brazil, India",
        zodiac: "Capricorn, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Purple_Agate.png?v=1738164570",
        chakra: "crown"
    },
    
        "stone-cherryblossomagate": {
        name: "Cherry Blossom Agate",
        description: "is a stone of nurturing, believed to inspire emotional growth and blossom new beginnings. Cherry Blossom Agate has been admired for its delicate pink patterns, reminiscent of cherry blossoms, symbolizing the transient beauty of life.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/cherry-blossom-64x.png?v=1681140781",
        hex: "#e9749d",
        property1: "nurturing",
        property2: "growth",
        short_description: "Cherry Blossom Agate is a stone of nurturing, believed to inspire emotional growth and blossom new beginnings.",
        website_description: "Cherry Blossom Agate is a stone of nurturing, believed to inspire emotional growth and blossom new beginnings. Cherry Blossom Agate has been admired for its delicate pink patterns, reminiscent of cherry blossoms, symbolizing the transient beauty of life.",
        origin: "Madagascar, Indonesia",
        zodiac: "Cancer, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Cherry_Blossom_Agate.png?v=1738164878",
        chakra: "heart"
    },
    
        "stone-bambooleafagate": {
        name: "Bamboo Leaf Agate",
        description: "is a stone of harmony, believed to balance emotions and rejuvenate the spirit. Bamboo Leaf Agate has been cherished in various cultures for its distinct leaf-like patterns, often seen as symbols of rebirth and growth.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/bamboo-leaf-agate-64x.png?v=1681140888",
        hex: "#4e483b",
        property1: "harmony",
        property2: "renewal",
        short_description: "Bamboo Leaf Agate is a stone of harmony, believed to balance emotions and rejuvenate the spirit.",
        website_description: "Bamboo Leaf Agate is a stone of harmony, believed to balance emotions and rejuvenate the spirit. Bamboo Leaf Agate has been cherished in various cultures for its distinct leaf-like patterns, often seen as symbols of rebirth and growth.",
        origin: "China, Indonesia",
        zodiac: "Taurus, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Bamboo_Leaf_Agate.png?v=1738165483",
        chakra: "heart"
    },
    
        "stone-greenphantomquartz": {
        name: "Green Phantom Quartz",
        description: "is a stone of growth, believed to inspire personal transformation and rejuvenation. In ancient times, Green Phantom Quartz was admired for its unique inclusions, symbolizing the continuous renewal of life's cycles.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/green-phantom-quartz-64x.png?v=1681141523",
        hex: "#6da34d",
        property1: "growth",
        property2: "renewal",
        short_description: "Green Phantom Quartz is a stone of growth, believed to inspire personal transformation and rejuvenation.",
        website_description: "Green Phantom Quartz is a stone of growth, believed to inspire personal transformation and rejuvenation. In ancient times, Green Phantom Quartz was admired for its unique inclusions, symbolizing the continuous renewal of life's cycles.",
        origin: "Brazil, United States",
        zodiac: "Capricorn, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Green_Phantom_Quartz.png?v=1738166003",
        chakra: "heart"
    },
    
        "stone-aquaterrajasperv2": {
        name: "Shoushan Snakeskin",
        description: "is a stone of harmony, believed to balance emotional energies and provide grounding protection. Shoushan Snakeskin has been revered in Chinese culture for its unique pattern and used in carvings to symbolize unity and safety.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/aqua_terra_jasper.png?v=1682962273",
        hex: "#b6dfed",
        property1: "harmony",
        property2: "protection",
        short_description: "Shoushan Snakeskin is a stone of harmony, believed to balance emotional energies and provide grounding protection.",
        website_description: "Shoushan Snakeskin is a stone of harmony, believed to balance emotional energies and provide grounding protection. Shoushan Snakeskin has been revered in Chinese culture for its unique pattern and used in carvings to symbolize unity and safety.",
        origin: "China, Taiwan",
        zodiac: "Pisces, Cancer",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Aqua_Terra_Jasper_c446799f-1b90-4c15-b2d4-9b05902f071b.png?v=1738166759",
        chakra: "sacral"
    },
    
        "stone-greengrapeagate": {
        name: "Green Grape Agate",
        description: "is a stone of serenity, believed to nurture a peaceful mind and rejuvenate spiritual energies. Ancient healers valued Green Grape Agate for its calming, grape-like formations, often used in meditative practices for mental clarity.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/green-grape-agate-64x.png?v=1681141669",
        hex: "#6ac044",
        property1: "serenity",
        property2: "renewal",
        short_description: "Green Grape Agate is a stone of serenity, believed to nurture a peaceful mind and rejuvenate spiritual energies.",
        website_description: "Green Grape Agate is a stone of serenity, believed to nurture a peaceful mind and rejuvenate spiritual energies. Ancient healers valued Green Grape Agate for its calming, grape-like formations, often used in meditative practices for mental clarity.",
        origin: "Indonesia, India",
        zodiac: "Cancer, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Green_Grape_Agate.png?v=1738167106",
        chakra: "crown"
    },
    
        "stone-kiwijasper": {
        name: "Kiwi Jasper",
        description: "is a stone of nurturing, believed to bring a sense of calm and emotional balance. Kiwi Jasper has been cherished in various cultures for its unique blend of colors, thought to symbolize the nurturing aspect of nature itself.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/kiwi-jasper-64x.png?v=1681141822",
        hex: "#77b5a4",
        property1: "nurturing",
        property2: "calm",
        short_description: "Kiwi Jasper is a stone of nurturing, believed to bring a sense of calm and emotional balance.",
        website_description: "Kiwi Jasper is a stone of nurturing, believed to bring a sense of calm and emotional balance. Kiwi Jasper has been cherished in various cultures for its unique blend of colors, thought to symbolize the nurturing aspect of nature itself.",
        origin: "New Zealand, India",
        zodiac: "Pisces, Cancer",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Kiwi_Jasper.png?v=1738167404",
        chakra: "heart"
    },
    
        "stone-emerald": {
        name: "Emerald",
        description: "is a stone of clarity, believed to enhance insight and rejuvenate the spirit. Famed throughout history, Emeralds were highly valued by ancient civilizations, such as the Incas and Egyptians, for their vibrant green hue and were often used in royal jewelry.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/emerald.png?v=1681141935",
        hex: "#50c878",
        property1: "clarity",
        property2: "renewal",
        short_description: "Emerald is a stone of clarity, believed to enhance insight and rejuvenate the spirit.",
        website_description: "Emerald is a stone of clarity, believed to enhance insight and rejuvenate the spirit. Famed throughout history, Emeralds were highly valued by ancient civilizations, such as the Incas and Egyptians, for their vibrant green hue and were often used in royal jewelry.",
        origin: "Colombia, Zambia",
        zodiac: "Aries, Gemini",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Emerald_e9d9a184-7917-435c-9408-55f942796036.png?v=1738168648",
        chakra: "heart"
    },
    
        "stone-chrysocolla": {
        name: "Chrysocolla",
        description: "is a stone of tranquility, believed to calm emotions and facilitate open communication. In ancient civilizations, Chrysocolla was used as a powerful tool for communication, held in high esteem for its ability to soothe and express emotions clearly.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/chrysocolla.png?v=1682961722",
        hex: "#007ba7",
        property1: "tranquility",
        property2: "communication",
        short_description: "Chrysocolla is a stone of tranquility, believed to calm emotions and facilitate open communication.",
        website_description: "Chrysocolla is a stone of tranquility, believed to calm emotions and facilitate open communication. In ancient civilizations, Chrysocolla was used as a powerful tool for communication, held in high esteem for its ability to soothe and express emotions clearly.",
        origin: "Peru, Mexico",
        zodiac: "Taurus, Gemini",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Chrysocolla_3000cd8d-c4fe-4d78-a228-626951aa4f29.png?v=1738168219",
        chakra: "throat"
    },
    
        "stone-creamriverstone": {
        name: "Cream Riverstone",
        description: "is a stone of stability, believed to bring a grounding and calming presence to one's environment. Cream Riverstone has been treasured in ancient cultures for its smooth texture and was often used in crafting tools and decorative items due to its durability and natural beauty.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/cream_riverstone.png?v=1682961625",
        hex: "#d2b48c",
        property1: "stability",
        property2: "calm",
        short_description: "Cream Riverstone is a stone of stability, believed to bring a grounding and calming presence to one's environment.",
        website_description: "Cream Riverstone is a stone of stability, believed to bring a grounding and calming presence to one's environment. Cream Riverstone has been treasured in ancient cultures for its smooth texture and was often used in crafting tools and decorative items due to its durability and natural beauty.",
        origin: "India, New Zealand",
        zodiac: "Taurus, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Cream_Riverstone_71140cde-6f9e-4eeb-ab86-816837881351.png?v=1738168366",
        chakra: "root"
    },
    
        "stone-yellowjade": {
        name: "Yellow Jade",
        description: "is a stone of harmony, believed to balance energies while inviting positivity into one's life. Yellow Jade has been revered in various cultures for its sunny hue, often used in amulets to promote joy and a harmonious environment.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/yellow_jade.png?v=1682961554",
        hex: "#fada5e",
        property1: "harmony",
        property2: "positivity",
        short_description: "Yellow Jade is a stone of harmony, believed to balance energies while inviting positivity into one's life.",
        website_description: "Yellow Jade is a stone of harmony, believed to balance energies while inviting positivity into one's life. Yellow Jade has been revered in various cultures for its sunny hue, often used in amulets to promote joy and a harmonious environment.",
        origin: "Myanmar, China",
        zodiac: "Leo, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Yellow_Jade_008f44f3-3861-482c-9fa0-562f30d6cf1a.png?v=1738168519",
        chakra: "solar-plexus"
    },
    
        "stone-treeagate": {
        name: "Tree Agate",
        description: "is a stone of stability, believed to foster personal growth and enhance the connection to nature. Tree Agate has been revered in various cultures for its tree-like patterns, symbolizing the bond between the earth and the heavens.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Untitled_design_10_b7a54289-3de5-43e0-9d74-624c162c9ef2.png?v=1680020788",
        hex: "#a9ba9d",
        property1: "stability",
        property2: "growth",
        short_description: "Tree Agate is a stone of stability, believed to foster personal growth and enhance the connection to nature.",
        website_description: "Tree Agate is a stone of stability, believed to foster personal growth and enhance the connection to nature. Tree Agate has been revered in various cultures for its tree-like patterns, symbolizing the bond between the earth and the heavens.",
        origin: "India, Brazil",
        zodiac: "Gemini, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Tree_Agate.png?v=1738169019",
        chakra: "heart"
    },
    
        "stone-leopardskinjasper": {
        name: "Leopard Skin Jasper",
        description: "is a stone of resilience, believed to fortify the spirit and offer protection during life's challenges. Ancient cultures revered Leopard Skin Jasper for its distinctive spotted patterns, often using it in amulets for strength and safeguarding.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/leopard-skin-jasper-64x.png?v=1681142395",
        hex: "#8e7b63",
        property1: "resilience",
        property2: "protection",
        short_description: "Leopard Skin Jasper is a stone of resilience, believed to fortify the spirit and offer protection during life's challenges.",
        website_description: "Leopard Skin Jasper is a stone of resilience, believed to fortify the spirit and offer protection during life's challenges. Ancient cultures revered Leopard Skin Jasper for its distinctive spotted patterns, often using it in amulets for strength and safeguarding.",
        origin: "Brazil, Madagascar",
        zodiac: "Sagittarius, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Leopard_Skin_Jasper.png?v=1738169355",
        chakra: "root"
    },
    
        "stone-violetlilacjasper": {
        name: "Violet Lilac Jasper",
        description: "is a stone of healing, believed to enhance intuitive abilities and spiritual growth. Historically, Violet Lilac Jasper has been used in spiritual practices for its soothing lilac tones and its connection to inner wisdom.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/violet-jasper-64x.png?v=1681142562",
        hex: "#9370db",
        property1: "healing",
        property2: "intuition",
        short_description: "Violet Lilac Jasper is a stone of healing, believed to enhance intuitive abilities and spiritual growth.",
        website_description: "Violet Lilac Jasper is a stone of healing, believed to enhance intuitive abilities and spiritual growth. Historically, Violet Lilac Jasper has been used in spiritual practices for its soothing lilac tones and its connection to inner wisdom.",
        origin: "India, Madagascar",
        zodiac: "Cancer, Aquarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Violet_Lilac_Jasper.png?v=1738169856",
        chakra: "third-eye"
    },
    
        "stone-galaxytigerseye": {
        name: "Galaxy Tiger's Eye",
        description: "is a stone of focus, believed to enhance concentration and bring mental clarity. Ancient civilizations esteemed Galaxy Tiger's Eye for its cosmic appearance, viewing it as a celestial guide to wisdom and insight.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/galaxy-tigers-eye-64x.png?v=1681142636",
        hex: "#4a1367",
        property1: "focus",
        property2: "clarity",
        short_description: "Galaxy Tiger's Eye is a stone of focus, believed to enhance concentration and bring mental clarity.",
        website_description: "Galaxy Tiger's Eye is a stone of focus, believed to enhance concentration and bring mental clarity. Ancient civilizations esteemed Galaxy Tiger's Eye for its cosmic appearance, viewing it as a celestial guide to wisdom and insight.",
        origin: "South Africa, India",
        zodiac: "Gemini, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Galaxy_Tiger_s_Eye.png?v=1738170194",
        chakra: "third-eye"
    },
    
        "stone-bluemagnesite": {
        name: "Blue Magnesite",
        description: "is a stone of serenity, believed to enhance inner peace and deepen awareness. Blue Magnesite has been appreciated in various cultures for its calming properties, often used in practices to still the mind and open the throat chakra.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/blue_magnesite.png?v=1682961290",
        hex: "#66ccff",
        property1: "serenity",
        property2: "awareness",
        short_description: "Blue Magnesite is a stone of serenity, believed to enhance inner peace and deepen awareness.",
        website_description: "Blue Magnesite is a stone of serenity, believed to enhance inner peace and deepen awareness. Blue Magnesite has been appreciated in various cultures for its calming properties, often used in practices to still the mind and open the throat chakra.",
        origin: "Brazil, United States",
        zodiac: "Pisces, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Blue_Magnesite_17fe1af7-5e47-4069-82bc-ac7d90ee708c.png?v=1738336969",
        chakra: "throat"
    },
    
        "stone-aquaterrajasper": {
        name: "Aqua Terra Jasper",
        description: "is a stone of harmony, believed to bring comfort and balance to the emotional body. Ancient cultures valued Aqua Terra Jasper for its unique appearance, often using it in talismans to promote tranquility and connection to nature.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/aqua_terra_jasper.png?v=1682962273",
        hex: "#b3dcea",
        property1: "harmony",
        property2: "comfort",
        short_description: "Aqua Terra Jasper is a stone of harmony, believed to bring comfort and balance to the emotional body.",
        website_description: "Aqua Terra Jasper is a stone of harmony, believed to bring comfort and balance to the emotional body. Ancient cultures valued Aqua Terra Jasper for its unique appearance, often using it in talismans to promote tranquility and connection to nature.",
        origin: "Australia, United States",
        zodiac: "Libra, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Aqua_Terra_Jasper_c446799f-1b90-4c15-b2d4-9b05902f071b.png?v=1738166759",
        chakra: "heart"
    },
    
        "stone-montanaagate": {
        name: "Montana Agate",
        description: "is a stone of tranquility, believed to promote emotional clarity and calmness. Montana Agate has been celebrated by Native American cultures for its intricate banding and symbolic connection to the serene landscapes of Montana.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/montana-agate-64px.png?v=1683902412",
        hex: "#b09773",
        property1: "tranquility",
        property2: "clarity",
        short_description: "Montana Agate is a stone of tranquility, believed to promote emotional clarity and calmness.",
        website_description: "Montana Agate is a stone of tranquility, believed to promote emotional clarity and calmness. Montana Agate has been celebrated by Native American cultures for its intricate banding and symbolic connection to the serene landscapes of Montana.",
        origin: "Montana, United States",
        zodiac: "Pisces, Sagittarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Montana_Agate.png?v=1738337358",
        chakra: "heart"
    },
    
        "stone-oceanjasper": {
        name: "Ocean Jasper",
        description: "is a stone of nurturing, believed to promote feelings of joy and emotional well-being. Ocean Jasper, often found along the shores of Madagascar, is prized for its unique patterns and vibrant colors which are thought to capture the essence of the sea.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Untitled_design.png?v=1683581216",
        hex: "#87ceeb",
        property1: "nurturing",
        property2: "positivity",
        short_description: "Ocean Jasper is a stone of nurturing, believed to promote feelings of joy and emotional well-being.",
        website_description: "Ocean Jasper is a stone of nurturing, believed to promote feelings of joy and emotional well-being. Ocean Jasper, often found along the shores of Madagascar, is prized for its unique patterns and vibrant colors which are thought to capture the essence of the sea.",
        origin: "Madagascar",
        zodiac: "Cancer, Pisces",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Ocean_Jasper.png?v=1738337822",
        chakra: "heart"
    },
    
        "stone-greentigerseye": {
        name: "Green Tiger's Eye",
        description: "is a stone of vitality, believed to enhance protection and invigorate the spirit. Green Tiger's Eye, known for its striking green bands, has historically been used as a talisman to promote inner strength and resilience.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/greentigerseye_2.png?v=1683582145",
        hex: "#4caf50",
        property1: "vitality",
        property2: "protection",
        short_description: "Green Tiger's Eye is a stone of vitality, believed to enhance protection and invigorate the spirit.",
        website_description: "Green Tiger's Eye is a stone of vitality, believed to enhance protection and invigorate the spirit. Green Tiger's Eye, known for its striking green bands, has historically been used as a talisman to promote inner strength and resilience.",
        origin: "South Africa, India",
        zodiac: "Leo, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Green_Tiger_s_Eye.png?v=1738338051",
        chakra: "heart"
    },
    
        "stone-lemonjade": {
        name: "Lemon Jade",
        description: "is a stone of optimism, believed to uplift the spirit and inspire positive energy. Ancient cultures revered Lemon Jade for its radiant hue, often using it in rituals to attract joy and health.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/lemon_jade_64px.png?v=1688408544",
        hex: "#efea9a",
        property1: "optimism",
        property2: "healing",
        short_description: "Lemon Jade is a stone of optimism, believed to uplift the spirit and inspire positive energy.",
        website_description: "Lemon Jade is a stone of optimism, believed to uplift the spirit and inspire positive energy. Ancient cultures revered Lemon Jade for its radiant hue, often using it in rituals to attract joy and health.",
        origin: "China, Nepal",
        zodiac: "Leo, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Lemon_Jade.png?v=1738338324",
        chakra: "solar-plexus"
    },
    
        "stone-whiteagate": {
        name: "White Agate",
        description: "is a stone of balance, believed to harmonize energies and provide protective support. Historically, White Agate has been valued for its gentle appearance and believed ability to promote emotional stability.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/white-agate-64px.png?v=1688408494",
        hex: "#f8f8ff",
        property1: "balance",
        property2: "protection",
        short_description: "White Agate is a stone of balance, believed to harmonize energies and provide protective support.",
        website_description: "White Agate is a stone of balance, believed to harmonize energies and provide protective support. Historically, White Agate has been valued for its gentle appearance and believed ability to promote emotional stability.",
        origin: "India, Brazil",
        zodiac: "Gemini, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/White_Agate.png?v=1738338405",
        chakra: "crown"
    },
    
        "stone-mapjasper": {
        name: "Map Jasper",
        description: "is a stone of stability, believed to fortify one's resolve and offer a protective shield against negative energies. Map Jasper has been cherished by ancient travelers for its unique patterns, often utilized as a talisman for safe journeys.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/map-jasper-64px.png?v=1688408512",
        hex: "#8b4513",
        property1: "stability",
        property2: "protection",
        short_description: "Map Jasper is a stone of stability, believed to fortify one's resolve and offer a protective shield against negative energies.",
        website_description: "Map Jasper is a stone of stability, believed to fortify one's resolve and offer a protective shield against negative energies. Map Jasper has been cherished by ancient travelers for its unique patterns, often utilized as a talisman for safe journeys.",
        origin: "India, Mexico",
        zodiac: "Capricorn, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Map_Jasper.png?v=1738338737",
        chakra: "root"
    },
    
        "stone-greenchlorite": {
        name: "Green Chlorite",
        description: "is a stone of healing, believed to cleanse the aura and rejuvenate the spirit. Green Chlorite has been used in holistic practices for its reputed ability to purify spaces and enhance energy flow.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/green_chorite_64px.png?v=1688408526",
        hex: "#82a47a",
        property1: "healing",
        property2: "cleansing",
        short_description: "Green Chlorite is a stone of healing, believed to cleanse the aura and rejuvenate the spirit.",
        website_description: "Green Chlorite is a stone of healing, believed to cleanse the aura and rejuvenate the spirit. Green Chlorite has been used in holistic practices for its reputed ability to purify spaces and enhance energy flow.",
        origin: "Brazil, Russia",
        zodiac: "Virgo, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Green_Chlorite.png?v=1738348033",
        chakra: "heart"
    },
    
        "stone-goldensheenobsidian": {
        name: "Golden Sheen Obsidian",
        description: "is a stone of reflection, believed to illuminate hidden truths and provide protective energies. In ancient Mesoamerican cultures, Golden Sheen Obsidian was used for making mirrors and scrying tools to reveal concealed insights.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/golden_sheen_obsidian_64px.png?v=1688408562",
        hex: "#70543e",
        property1: "reflection",
        property2: "protection",
        short_description: "Golden Sheen Obsidian is a stone of reflection, believed to illuminate hidden truths and provide protective energies.",
        website_description: "Golden Sheen Obsidian is a stone of reflection, believed to illuminate hidden truths and provide protective energies. In ancient Mesoamerican cultures, Golden Sheen Obsidian was used for making mirrors and scrying tools to reveal concealed insights.",
        origin: "Mexico, United States",
        zodiac: "Scorpio, Sagittarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Golden_Sheen_Obsidian.png?v=1738348753",
        chakra: "solar-plexus"
    },
    
        "stone-botswanaagate": {
        name: "Botswana Agate",
        description: "is a stone of soothing, believed to calm the mind and provide inner stability. Botswana Agate has been admired for its beautiful banded patterns, often used in meditation practices for its grounding properties.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Untitled_design_68.png?v=1689088737",
        hex: "#8a4e39",
        property1: "soothing",
        property2: "stability",
        short_description: "Botswana Agate is a stone of soothing, believed to calm the mind and provide inner stability.",
        website_description: "Botswana Agate is a stone of soothing, believed to calm the mind and provide inner stability. Botswana Agate has been admired for its beautiful banded patterns, often used in meditation practices for its grounding properties.",
        origin: "Botswana, South Africa",
        zodiac: "Taurus, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Botswana_Agate.png?v=1738703098",
        chakra: "root"
    },
    
        "stone-angelauraquartz": {
        name: "Angel Aura Quartz",
        description: "is a stone of upliftment, believed to elevate the spirit and provide mental clarity. Angel Aura Quartz, known for its iridescent sheen, is often used in modern energy practices to enhance meditation and spiritual growth.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/angel_aura_quartz.jpg?v=1691003023",
        hex: "#d8cff8",
        property1: "upliftment",
        property2: "clarity",
        short_description: "Angel Aura Quartz is a stone of upliftment, believed to elevate the spirit and provide mental clarity.",
        website_description: "Angel Aura Quartz is a stone of upliftment, believed to elevate the spirit and provide mental clarity. Angel Aura Quartz, known for its iridescent sheen, is often used in modern energy practices to enhance meditation and spiritual growth.",
        origin: "Brazil, United States",
        zodiac: "Gemini, Aquarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Angel_Aura_Quartz.png?v=1738703258",
        chakra: "crown"
    },
    
        "stone-mookaite": {
        name: "Mookaite",
        description: "is a stone of vitality, believed to rejuvenate the spirit and foster a sense of stability. Mookaite has been revered by Aboriginal tribes in Australia for its vibrant colors and grounding energy, often used in healing rituals.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/mookaite-64px.png?v=1693586149",
        hex: "#b04f35",
        property1: "vitality",
        property2: "stability",
        short_description: "Mookaite is a stone of vitality, believed to rejuvenate the spirit and foster a sense of stability.",
        website_description: "Mookaite is a stone of vitality, believed to rejuvenate the spirit and foster a sense of stability. Mookaite has been revered by Aboriginal tribes in Australia for its vibrant colors and grounding energy, often used in healing rituals.",
        origin: "Australia",
        zodiac: "Virgo, Aquarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Mookaite.png?v=1738703745",
        chakra: "solar-plexus"
    },
    
        "stone-greenzebrajasper": {
        name: "Green Zebra Jasper",
        description: "is a stone of balance, believed to harmonize energies and revitalize the spirit. Green Zebra Jasper, with its striking green and white patterns, has been admired for its unique appearance and used in ancient healing practices.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/green-zebra-jasper-64px.png?v=1693586149",
        hex: "#7cb342",
        property1: "balance",
        property2: "vitality",
        short_description: "Green Zebra Jasper is a stone of balance, believed to harmonize energies and revitalize the spirit.",
        website_description: "Green Zebra Jasper is a stone of balance, believed to harmonize energies and revitalize the spirit. Green Zebra Jasper, with its striking green and white patterns, has been admired for its unique appearance and used in ancient healing practices.",
        origin: "Brazil, India",
        zodiac: "Virgo, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Green_Zebra_Jasper.png?v=1738704020",
        chakra: "heart"
    },
    
        "stone-rainbowmorganite": {
        name: "Rainbow Morganite",
        description: "is a stone of alignment, believed to harmonize personal energies and elevate the spirit. Rainbow Morganite has been beloved for its multicolored beauty and used in various cultural rituals to signify joy and alignment with life’s flow.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/dave_single_raw_pink_morganite_tumbled_gemstone_on_a_white_back_190eb88f-d073-4ecb-87a9-c59c37a61abd.png?v=1695835917",
        hex: "#ff9cd0",
        property1: "alignment",
        property2: "joy",
        short_description: "Rainbow Morganite is a stone of alignment, believed to harmonize personal energies and elevate the spirit.",
        website_description: "Rainbow Morganite is a stone of alignment, believed to harmonize personal energies and elevate the spirit. Rainbow Morganite has been beloved for its multicolored beauty and used in various cultural rituals to signify joy and alignment with life’s flow.",
        origin: "Brazil, Madagascar",
        zodiac: "Libra, Cancer",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Rainbow_Morganite.png?v=1738704214",
        chakra: "heart"
    },
    
        "stone-dragonveinagate": {
        name: "Dragon Vein Agate",
        description: "is a stone of empowerment, believed to enhance inner strength and fortify one's resolve. Throughout history, Dragon Vein Agate has been admired for its dragon-like veins, symbolizing protection and strength.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/dragon_vien_64.jpg?v=1699009595",
        hex: "#6e3b3b",
        property1: "empowerment",
        property2: "protection",
        short_description: "Dragon Vein Agate is a stone of empowerment, believed to enhance inner strength and fortify one's resolve.",
        website_description: "Dragon Vein Agate is a stone of empowerment, believed to enhance inner strength and fortify one's resolve. Throughout history, Dragon Vein Agate has been admired for its dragon-like veins, symbolizing protection and strength.",
        origin: "Brazil, China",
        zodiac: "Aries, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Dragon_Vein_Agate.png?v=1738704425",
        chakra: "root"
    },
    
        "stone-iolite": {
        name: "Iolite",
        description: "is a stone of vision, believed to enhance inner insight and open the path to deep understanding. Historically, Iolite has been used by Viking navigators as a polarizing lens to locate the sun on cloudy days, aiding in their journeys.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/iolite_stone.jpg",
        hex: "#5072a7",
        property1: "vision",
        property2: "intuition",
        short_description: "Iolite is a stone of vision, believed to enhance inner insight and open the path to deep understanding.",
        website_description: "Iolite is a stone of vision, believed to enhance inner insight and open the path to deep understanding. Historically, Iolite has been used by Viking navigators as a polarizing lens to locate the sun on cloudy days, aiding in their journeys.",
        origin: "India, Madagascar",
        zodiac: "Libra, Sagittarius",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Lolite.png?v=1738704550",
        chakra: "third-eye"
    },
    
        "stone-woodjasper": {
        name: "Wood Jasper",
        description: "is a stone of resilience, believed to harmonize one's energies and provide a grounding influence. Wood Jasper, with its intricate wood-like patterns, has been appreciated by indigenous cultures for its connection to the earth and its healing properties.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Untitled_design_89.png?v=1706719609",
        hex: "#964b00",
        property1: "resilience",
        property2: "harmony",
        short_description: "Wood Jasper is a stone of resilience, believed to harmonize one's energies and provide a grounding influence.",
        website_description: "Wood Jasper is a stone of resilience, believed to harmonize one's energies and provide a grounding influence. Wood Jasper, with its intricate wood-like patterns, has been appreciated by indigenous cultures for its connection to the earth and its healing properties.",
        origin: "Indonesia, United States",
        zodiac: "Capricorn, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Wood_Jasper.png?v=1738704758",
        chakra: "root"
    },
    
        "stone-zebrajasper": {
        name: "Zebra Jasper",
        description: "is a stone of balance, believed to harmonize energies and enhance physical and mental strength. Zebra Jasper, with its striking zebra-like patterns, has been valued by ancient cultures for its grounding properties and ability to bring stability during turbulent times.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/zebra_jasper_1_1.png?v=1712015968",
        hex: "#a58f76",
        property1: "balance",
        property2: "strength",
        short_description: "Zebra Jasper is a stone of balance, believed to harmonize energies and enhance physical and mental strength.",
        website_description: "Zebra Jasper is a stone of balance, believed to harmonize energies and enhance physical and mental strength. Zebra Jasper, with its striking zebra-like patterns, has been valued by ancient cultures for its grounding properties and ability to bring stability during turbulent times.",
        origin: "India, South Africa",
        zodiac: "Gemini, Taurus",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Zebra_Jasper.png?v=1738704688",
        chakra: "root"
    },
    
        "stone-pinkplumtourmaline": {
        name: "Pink Plum Tourmaline",
        description: "is a stone of love, believed to support emotional healing and foster a sense of warmth. Throughout history, Pink Plum Tourmaline has been admired for its deep pink hues, often used in romantic rituals and adornments to symbolize passion and affection.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/pinkplumtournalime.png?v=1713457605",
        hex: "#ff66b2",
        property1: "love",
        property2: "healing",
        short_description: "Pink Plum Tourmaline is a stone of love, believed to support emotional healing and foster a sense of warmth.",
        website_description: "Pink Plum Tourmaline is a stone of love, believed to support emotional healing and foster a sense of warmth. Throughout history, Pink Plum Tourmaline has been admired for its deep pink hues, often used in romantic rituals and adornments to symbolize passion and affection.",
        origin: "Brazil, Madagascar",
        zodiac: "Scorpio, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Pink_Plum_Tourmaline.png?v=1738704920",
        chakra: "heart"
    },
    
        "stone-russianserpentine": {
        name: "Russian Serpentine",
        description: "is a stone of healing, believed to fortify the spirit and provide protective support. Ancient cultures in Russia treasured Serpentine for its vibrant green hues and used it in various amulets for protection and healing rituals.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/1261651.jpg?v=1719853379",
        hex: "#6e6e4e",
        property1: "healing",
        property2: "protection",
        short_description: "Russian Serpentine is a stone of healing, believed to fortify the spirit and provide protective support.",
        website_description: "Russian Serpentine is a stone of healing, believed to fortify the spirit and provide protective support. Ancient cultures in Russia treasured Serpentine for its vibrant green hues and used it in various amulets for protection and healing rituals.",
        origin: "Russia, South Africa",
        zodiac: "Gemini, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Russian_Serpentine.png?v=1738705050",
        chakra: "root"
    },
    
        "stone-brecciatedjasper": {
        name: "Brecciated Jasper",
        description: "is a stone of strength, believed to stabilize energies and invigorate the spirit. Ancient warriors valued Brecciated Jasper for its bold patterns and used it as a protective amulet in battles.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Copy_of_Untitled_64_x_64_px_1.png?v=1720223186",
        hex: "#a0522d",
        property1: "strength",
        property2: "vitality",
        short_description: "Brecciated Jasper is a stone of strength, believed to stabilize energies and invigorate the spirit.",
        website_description: "Brecciated Jasper is a stone of strength, believed to stabilize energies and invigorate the spirit. Ancient warriors valued Brecciated Jasper for its bold patterns and used it as a protective amulet in battles.",
        origin: "Brazil, South Africa",
        zodiac: "Leo, Aries",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Brecciated_Jasper.png?v=1737147460",
        chakra: "root"
    },
    
        "stone-indianbloodstone": {
        name: "Indian Bloodstone",
        description: "is a stone of vitality, believed to invigorate the spirit and encourage courage in challenging times. In ancient cultures, Indian Bloodstone was treasured for its deep red and green hues, often used in amulets to protect warriors and enhance their strength.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/bloodstone_tumbled.png?v=1721853290",
        hex: "#4a5d23",
        property1: "vitality",
        property2: "courage",
        short_description: "Indian Bloodstone is a stone of vitality, believed to invigorate the spirit and encourage courage in challenging times.",
        website_description: "Indian Bloodstone is a stone of vitality, believed to invigorate the spirit and encourage courage in challenging times. In ancient cultures, Indian Bloodstone was treasured for its deep red and green hues, often used in amulets to protect warriors and enhance their strength.",
        origin: "India, Australia",
        zodiac: "Aries, Libra",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Indian_Bloodstone.png?v=1737147188",
        chakra: "root"
    },
    
        "stone-magnesite": {
        name: "Magnesite",
        description: "is a stone of reflection, believed to deepen self-awareness and promote introspection. Ancient civilizations valued Magnesite for its milky-white appearance, using it in meditation practices to enhance inner clarity.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/tumbled_stone.png?v=1721853517",
        hex: "#e4e3db",
        property1: "reflection",
        property2: "awareness",
        short_description: "Magnesite is a stone of reflection, believed to deepen self-awareness and promote introspection.",
        website_description: "Magnesite is a stone of reflection, believed to deepen self-awareness and promote introspection. Ancient civilizations valued Magnesite for its milky-white appearance, using it in meditation practices to enhance inner clarity.",
        origin: "Australia, Austria",
        zodiac: "Pisces, Virgo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Magnesite.png?v=1737146803",
        chakra: "third-eye"
    },
    
        "stone-snowflakeobsidian": {
        name: "Snowflake Obsidian",
        description: "is a stone of purity, believed to bring clarity of mind and protect against emotional burdens. Historically, Snowflake Obsidian has been used in spiritual practices to balance the body, mind, and spirit, and dispel negative thoughts.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/tumbled_stone_567e8461-93c9-4cd6-aaff-7ea63bfc73aa.png?v=1722009564",
        hex: "#4f4f4f",
        property1: "purity",
        property2: "protection",
        short_description: "Snowflake Obsidian is a stone of purity, believed to bring clarity of mind and protect against emotional burdens.",
        website_description: "Snowflake Obsidian is a stone of purity, believed to bring clarity of mind and protect against emotional burdens. Historically, Snowflake Obsidian has been used in spiritual practices to balance the body, mind, and spirit, and dispel negative thoughts.",
        origin: "United States, Iceland",
        zodiac: "Virgo, Capricorn",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/Snowflake_Obsidian.png?v=1737146669",
        chakra: "root"
    },
    
        "stone-orangeaventurine": {
        name: "Orange Aventurine",
        description: "is a stone of creativity, believed to spark imagination and inspire a positive outlook. Orange Aventurine has been admired for its warm tones and used in ancient artistic rituals to invoke inspiration and happiness.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/orange-aventurine-stone-Photoroom.png?v=1735676626",
        hex: "#f4a460",
        property1: "creativity",
        property2: "positivity",
        short_description: "Orange Aventurine is a stone of creativity, believed to spark imagination and inspire a positive outlook.",
        website_description: "Orange Aventurine is a stone of creativity, believed to spark imagination and inspire a positive outlook. Orange Aventurine has been admired for its warm tones and used in ancient artistic rituals to invoke inspiration and happiness.",
        origin: "India, Brazil",
        zodiac: "Libra, Leo",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/orange_aventurine.png?v=1736539231",
        chakra: "sacral"
    },
    
        "stone-yellowhoneycalcite": {
        name: "Yellow Honey Calcite",
        description: "is a stone of positivity, believed to inspire renewed energy and a brighter outlook on life. Yellow Honey Calcite has been valued in ancient cultures for its warm golden hue, often used in rituals to invoke sunlight and vitality.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/yellow-honey-calcite-stone-Photoroom.png?v=1735677660",
        hex: "#ffb84d",
        property1: "positivity",
        property2: "renewal",
        short_description: "Yellow Honey Calcite is a stone of positivity, believed to inspire renewed energy and a brighter outlook on life.",
        website_description: "Yellow Honey Calcite is a stone of positivity, believed to inspire renewed energy and a brighter outlook on life. Yellow Honey Calcite has been valued in ancient cultures for its warm golden hue, often used in rituals to invoke sunlight and vitality.",
        origin: "Mexico, Madagascar",
        zodiac: "Leo, Cancer",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/yellow_honey_calcite.png?v=1736539024",
        chakra: "solar-plexus"
    },
    
        "stone-watermelontourmaline": {
        name: "Watermelon Tourmaline",
        description: "is a stone of balance, believed to harmonize emotional energies and inspire a joyful perspective. Watermelon Tourmaline, known for its vibrant pink and green bands, has been cherished for centuries as a symbol of unity and love, often used in ancient adornments to represent emotional healing.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/watermelon-tourmaline-stone-Photoroom.png?v=1735680167",
        hex: "#f08080",
        property1: "balance",
        property2: "joy",
        short_description: "Watermelon Tourmaline is a stone of balance, believed to harmonize emotional energies and inspire a joyful perspective.",
        website_description: "Watermelon Tourmaline is a stone of balance, believed to harmonize emotional energies and inspire a joyful perspective. Watermelon Tourmaline, known for its vibrant pink and green bands, has been cherished for centuries as a symbol of unity and love, often used in ancient adornments to represent emotional healing.",
        origin: "Brazil, Afghanistan",
        zodiac: "Cancer, Gemini",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/watermelon_tourmaline.png?v=1736538755",
        chakra: "heart"
    },
    
        "stone-orangeaventurinev2": {
        name: "Orange Aventurine",
        description: "is a stone of creativity, believed to spark imagination and inspire a positive outlook. Orange Aventurine has been admired for its warm tones and used in ancient artistic rituals to invoke inspiration and happiness.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/orange-aventurine-stone-2.png?v=1735681836",
        hex: "#fbcd7e",
        property1: "undefined",
        property2: "undefined",
        short_description: "Orange Aventurine is a stone of creativity, believed to spark imagination and inspire a positive outlook.",
        website_description: "Orange Aventurine is a stone of creativity, believed to spark imagination and inspire a positive outlook. Orange Aventurine has been admired for its warm tones and used in ancient artistic rituals to invoke inspiration and happiness.",
        origin: "India, China",
        zodiac: "Leo, Aries",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/orange_aventurine_v2.png?v=1736539159",
        chakra: "sacral"
    },
    
        "stone-smokeyquartz": {
        name: "Smokey Quartz",
        description: "is a stone of protection, believed to ward off negative energies and provide a strong grounding presence. Smokey Quartz has been treasured by ancient druids for its connection to the earth, using it in rituals to amplify grounding and protective energies.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/smokey-quartz-stone-Photoroom.png?v=1735682657",
        hex: "#7d5a4f",
        property1: "protection",
        property2: "grounding",
        short_description: "Smokey Quartz is a stone of protection, believed to ward off negative energies and provide a strong grounding presence.",
        website_description: "Smokey Quartz is a stone of protection, believed to ward off negative energies and provide a strong grounding presence. Smokey Quartz has been treasured by ancient druids for its connection to the earth, using it in rituals to amplify grounding and protective energies.",
        origin: "United States, Brazil",
        zodiac: "Capricorn, Scorpio",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/smokey_quartz.png?v=1736538133",
        chakra: "root"
    },
    
        "stone-goldstone": {
        name: "Goldstone",
        description: "is a stone of ambition, believed to inspire drive and encourage unwavering determination. Goldstone, said to originate from 17th-century Venetian alchemists, has been admired for its glittering surface resembling stardust and used as a symbol of ingenuity and perseverance.", 
        icon: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/goldstone-stone-Photoroom.png?v=1735683115",
        hex: "#c35004",
        property1: "undefined",
        property2: "undefined",
        short_description: "Goldstone is a stone of ambition, believed to inspire drive and encourage unwavering determination.",
        website_description: "Goldstone is a stone of ambition, believed to inspire drive and encourage unwavering determination. Goldstone, said to originate from 17th-century Venetian alchemists, has been admired for its glittering surface resembling stardust and used as a symbol of ingenuity and perseverance.",
        origin: "Italy, United States",
        zodiac: "Leo, Aries",
        tumbled: "https://cdn.shopify.com/s/files/1/0121/4254/2912/files/goldstone.png?v=1736537884",
        chakra: "sacral"
    },
}